import * as i1$1 from '@angular/common';
import { DOCUMENT, formatDate, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Component, ChangeDetectionStrategy, Inject, Input, EventEmitter, Output, ViewChild, Pipe, Directive, TemplateRef, NgModule, ɵunwrapSafeValue as _unwrapSafeValue } from '@angular/core';
import * as i3 from '@angular/forms';
import { UntypedFormControl, Validators, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import * as i5 from 'ng-recaptcha-2';
import { RecaptchaComponent, RecaptchaModule } from 'ng-recaptcha-2';
import * as i4 from 'ngx-bootstrap/alert';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ReplaySubject, BehaviorSubject, combineLatest, catchError as catchError$1, map as map$1, take as take$1, of, Observable } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/platform-browser';
import { map, filter, catchError, tap, take, switchMap, mapTo, shareReplay, withLatestFrom } from 'rxjs/operators';
import * as i1$2 from 'ngx-bootstrap/modal';
import { SubSink } from 'subsink';
import moment from 'moment-mini';
import * as i2$1 from '@angular/router';
import Enumerable from 'linq';
class AppSettings {
  static {
    this.ɵfac = function AppSettings_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppSettings)();
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: AppSettings,
      factory: AppSettings.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppSettings, [{
    type: Injectable
  }], null, null);
})();
const WindowToken = new InjectionToken('WindowToken');
const _c0$3 = ["*"];
function D7AjaxBlockComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const Content_r1 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("outerHTML", Content_r1, i0.ɵɵsanitizeHtml);
  }
}
function D7AjaxBlockComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["slot", "loading"]);
  }
}
class D7AjaxBlockComponent {
  constructor(http, sanitizer, window) {
    this.http = http;
    this.sanitizer = sanitizer;
    this.Content$ = new ReplaySubject(1);
    this.window = window;
  }
  ngOnInit() {
    if (this.module && this.delta) {
      const path = this.window.location.pathname.substring(1);
      this.http.get(`/load-block-on-ajax/${this.module}-${this.delta}`, {
        params: {
          path
        }
      }).subscribe({
        next: results => {
          this.Content$.next(this.sanitizer.bypassSecurityTrustHtml(results.content));
        }
      });
    }
  }
  static {
    this.ɵfac = function D7AjaxBlockComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || D7AjaxBlockComponent)(i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.DomSanitizer), i0.ɵɵdirectiveInject(WindowToken));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: D7AjaxBlockComponent,
      selectors: [["pac-d7-ajax-block"]],
      inputs: {
        module: "module",
        delta: "delta"
      },
      ngContentSelectors: _c0$3,
      decls: 4,
      vars: 4,
      consts: [["loading", ""], [4, "ngIf", "ngIfElse"], [3, "outerHTML"]],
      template: function D7AjaxBlockComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, D7AjaxBlockComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, D7AjaxBlockComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r2 = i0.ɵɵreference(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.Content$))("ngIfElse", loading_r2);
        }
      },
      dependencies: [i1$1.NgIf, i1$1.AsyncPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(D7AjaxBlockComponent, [{
    type: Component,
    args: [{
      selector: 'pac-d7-ajax-block',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "\r\n<ng-container *ngIf=\"Content$ | async as Content; else loading\">\r\n\t<div [outerHTML]=\"Content\"></div>\r\n</ng-container>\r\n\r\n<ng-template #loading>\r\n\t<ng-content slot=\"loading\"></ng-content>\r\n</ng-template>\r\n"
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.DomSanitizer
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WindowToken]
    }]
  }], {
    module: [{
      type: Input
    }],
    delta: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(D7AjaxBlockComponent, {
    className: "D7AjaxBlockComponent",
    filePath: "lib\\components\\d7-ajax-block\\d7-ajax-block.component.ts",
    lineNumber: 14
  });
})();
function DynamicModalComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
class DynamicModalComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function DynamicModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DynamicModalComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: DynamicModalComponent,
      selectors: [["ng-component"]],
      decls: 1,
      vars: 2,
      consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function DynamicModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, DynamicModalComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngTemplateOutlet", ctx.Template)("ngTemplateOutletContext", ctx.Context);
        }
      },
      dependencies: [i1$1.NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicModalComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<ng-container *ngTemplateOutlet=\"Template; context: Context\"></ng-container>\r\n"
    }]
  }], () => [], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicModalComponent, {
    className: "DynamicModalComponent",
    filePath: "lib\\components\\dynamic-modal\\dynamic-modal.component.ts",
    lineNumber: 7
  });
})();
function FetchModalComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "h4", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 6);
    i0.ɵɵlistener("click", function FetchModalComponent_div_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.Close());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.Title);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", ctx_r1.CloseText);
  }
}
function FetchModalComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function FetchModalComponent_div_4_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.Close());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.CloseText);
  }
}
class FetchModalComponent {
  constructor(modal, http, document) {
    this.modal = modal;
    this.http = http;
    this.document = document;
    this.Title = null;
    this.CloseText = 'Close';
    this.OnClose = new EventEmitter();
    this.Selector = ['#block-pac-theme-mainpagecontent', '#block-system-main'];
  }
  ngOnInit() {
    const selectors = this.Selector instanceof Array ? this.Selector : [this.Selector];
    this.Content$ = this.http.get(this.Href.toString(), {
      responseType: 'text'
    }).pipe(map(response => {
      const doc = document.implementation.createHTMLDocument(this.Title || 'Fetch Modal');
      doc.documentElement.innerHTML = response;
      if (this.Title !== false) {
        this.Title = doc.title.split('|')[0].trim();
      }
      for (const selector of selectors) {
        const main = doc.querySelector(selector);
        if (main) {
          return main.innerHTML;
        }
      }
      return null;
    }));
  }
  Close() {
    this.OnClose.emit();
    this.modal.hide();
  }
  static {
    this.ɵfac = function FetchModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FetchModalComponent)(i0.ɵɵdirectiveInject(i1$2.BsModalRef), i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(DOCUMENT));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: FetchModalComponent,
      selectors: [["ng-component"]],
      decls: 5,
      vars: 5,
      consts: [["class", "modal-header", 4, "ngIf"], [1, "modal-body"], [3, "innerHTML"], ["class", "modal-footer", 4, "ngIf"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-bs-dismiss", "modal", 1, "btn-close", 3, "click"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-danger", "text-light", 3, "click"]],
      template: function FetchModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FetchModalComponent_div_0_Template, 4, 2, "div", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵelement(2, "div", 2);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, FetchModalComponent_div_4_Template, 3, 1, "div", 3);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.Title);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(3, 3, ctx.Content$), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.CloseText);
        }
      },
      dependencies: [i1$1.NgIf, i1$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FetchModalComponent, [{
    type: Component,
    args: [{
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div *ngIf=\"Title\" class=\"modal-header\">\r\n  <h4 class=\"modal-title\">{{ Title }}</h4>\r\n  <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" [attr.aria-label]=\"CloseText\" (click)=\"Close();\"></button>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div [innerHTML]=\"Content$ | async\"></div>\r\n</div>\r\n<div *ngIf=\"CloseText\" class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-danger text-light\" (click)=\"Close()\">{{ CloseText }}</button>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1$2.BsModalRef
  }, {
    type: i1.HttpClient
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FetchModalComponent, {
    className: "FetchModalComponent",
    filePath: "lib\\components\\fetch-modal\\fetch-modal.component.ts",
    lineNumber: 13
  });
})();
const _c0$2 = ["*"];
class LoadingComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function LoadingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: LoadingComponent,
      selectors: [["pac-loading"]],
      ngContentSelectors: _c0$2,
      decls: 2,
      vars: 0,
      consts: [[1, "visually-hidden"]],
      template: function LoadingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;animation:_ngcontent-%COMP%_spinner-border .75s linear infinite}@keyframes _ngcontent-%COMP%_spinner-border{to{transform:rotate(360deg)}}.sm[_nghost-%COMP%]{width:1rem;height:1rem;border-width:.2em}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingComponent, [{
    type: Component,
    args: [{
      selector: 'pac-loading',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<span class=\"visually-hidden\">\r\n    <ng-content></ng-content>\r\n</span>\r\n",
      styles: [":host{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;animation:spinner-border .75s linear infinite}@keyframes spinner-border{to{transform:rotate(360deg)}}:host.sm{width:1rem;height:1rem;border-width:.2em}\n"]
    }]
  }], () => [], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoadingComponent, {
    className: "LoadingComponent",
    filePath: "lib\\components\\loading\\loading.component.ts",
    lineNumber: 9
  });
})();
var ApiErrors;
(function (ApiErrors) {
  ApiErrors["LoginRequired"] = "login-required";
  ApiErrors["Recaptcha"] = "recaptcha";
  ApiErrors["Empty"] = "empty";
  ApiErrors["AlreadyLoggedIn"] = "logged-in";
  ApiErrors["Exception"] = "exception";
  ApiErrors["RateLimit"] = "limit";
  ApiErrors["LockNotAcquired"] = "lock";
})(ApiErrors || (ApiErrors = {}));
class ApiError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
    this.name = 'ApiError';
  }
}
function ApiErrorHandler(error, caught) {
  if (error.error && 'code' in error.error) {
    switch (error.error.code) {
      case ApiErrors.LoginRequired:
        throw new ApiError('Login Required', ApiErrors.LoginRequired);
      case ApiErrors.Exception:
        throw new ApiError(error.error.message, ApiErrors.Exception);
      case ApiErrors.Recaptcha:
        throw new ApiError('Failed to validate security check. Please try again.', ApiErrors.Recaptcha);
      case ApiErrors.LockNotAcquired:
        throw new ApiError('Could not acquire exclusive lock. Please wait and try again.', ApiErrors.LockNotAcquired);
      case ApiErrors.RateLimit:
        throw new ApiError('Rate limit exceeded. Please contact us for further assistance.', ApiErrors.RateLimit);
    }
  }
  if (error.status === 0) {
    throw new Error(`${error.name}: ${error.message}`);
  }
  throw new Error(`${error.statusText}: ${error.status} ${error.error}`);
}
function LoginExceptionRedirect(error) {
  if (error instanceof ApiError) {
    if (error.code === ApiErrors.LoginRequired) {
      window.location.href = '/members?refresh=1&destination=/members/my-membership';
    }
  }
}
const LoginExceptionRedirectFactory = url => error => {
  if (error instanceof ApiError) {
    if (error.code === ApiErrors.LoginRequired) {
      window.location.href = '/members?refresh=1&destination=' + url;
    }
  }
};
const LoginExceptionRedirectToken = new InjectionToken('LoginExceptionRedirect');

// tslint:disable: variable-name
class CustomerPaymentInfo {
  get cpi_apm_key() {
    return this.apm_key;
  }
  set cpi_apm_key(value) {
    this.apm_key = value;
  }
  constructor(source) {
    this.cpi_key = undefined;
    this.cpi_cst_key = undefined;
    this.apm_key = undefined;
    this.apm_type = undefined;
    this.apm_method = undefined;
    this.cpi_cc_number_display = undefined;
    this.cpi_cc_expire = undefined;
    this.cpi_cc_cardholder_name = undefined;
    this.cpi_name_on_check = undefined;
    this.cpi_eft_routing_number = undefined;
    this.cpi_eft_account_number_display = undefined;
    this.cpi_eft_account_type = undefined;
    this.cpi_street = undefined;
    this.cpi_city = undefined;
    this.cpi_state = undefined;
    this.cpi_zip = undefined;
    this.cpi_cty_iso_number = undefined;
    this.cpi_preferred_flag = undefined;
    if (source) {
      ['cpi_cc_number', 'cpi_temp_cc_number', 'cpi_cc_security_code'].forEach(k => {
        if (k in source) {
          delete source[k];
        }
      });
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
class CustomerPaymentInfoService {
  get CustomerPaymentInfo$() {
    return this.customerPaymentInfo$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings, loginExceptionRedirect) {
    this.http = http;
    this.settings = settings;
    this.loginExceptionRedirect = loginExceptionRedirect;
    this.customerPaymentInfo$ = new BehaviorSubject(undefined);
    this.reset = false;
    this.endpoint = settings.pac_base_nf_url + 'api/CustomerPaymentInfo';
  }
  Get(cached = true) {
    if (cached && this.customerPaymentInfo$.value && this.reset === false) {
      return this.CustomerPaymentInfo$;
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(trm => new CustomerPaymentInfo(trm));
      }
      return null;
    })).subscribe({
      next: results => {
        if (results instanceof Array) {
          this.reset = false;
          this.customerPaymentInfo$.next(results);
        }
      },
      error: this.loginExceptionRedirect
    });
    return this.CustomerPaymentInfo$;
  }
  Reset() {
    this.reset = true;
  }
  Update(cpi, gRecaptchResponse) {
    const params = {
      Site: this.settings.pac_base_asn_code,
      gRecaptchResponse
    };
    return this.http.put(this.endpoint + '/' + cpi.cpi_key, cpi, {
      params,
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cpi_key' in result) {
        return new CustomerPaymentInfo(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof CustomerPaymentInfo) {
        this.reset = true;
        this.refresh(result);
      }
    }), tap({
      error: this.loginExceptionRedirect
    }));
  }
  Insert(cpi, gRecaptchResponse) {
    const params = {
      Site: this.settings.pac_base_asn_code,
      gRecaptchResponse
    };
    return this.http.post(this.endpoint, cpi, {
      params,
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cpi_key' in result) {
        return new CustomerPaymentInfo(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof CustomerPaymentInfo) {
        this.reset = true;
        this.refresh(result);
      }
    }), tap({
      error: this.loginExceptionRedirect
    }));
  }
  Delete(cpi) {
    return this.http.delete(this.endpoint + '/' + cpi.cpi_key, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), tap(() => {
      this.reset = true;
      if (cpi && this.customerPaymentInfo$.value instanceof Array) {
        const update = [...this.customerPaymentInfo$.value];
        this.customerPaymentInfo$.next(update.filter(item => item.cpi_key !== cpi.cpi_key));
      }
    }), tap({
      error: this.loginExceptionRedirect
    }));
  }
  refresh(cpi) {
    if (cpi && this.customerPaymentInfo$.value instanceof Array) {
      const update = [...this.customerPaymentInfo$.value];
      const existing = update.findIndex(item => item.cpi_key === cpi.cpi_key);
      if (existing >= 0) {
        update.splice(existing, 1, cpi);
      } else {
        update.push(cpi);
      }
      this.customerPaymentInfo$.next(update);
    }
  }
  static {
    this.ɵfac = function CustomerPaymentInfoService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomerPaymentInfoService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings), i0.ɵɵinject(LoginExceptionRedirectToken));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: CustomerPaymentInfoService,
      factory: CustomerPaymentInfoService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomerPaymentInfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LoginExceptionRedirectToken]
    }]
  }], null);
})();
class PaymentBeforeSave {
  constructor(form, confirm, resume) {
    this.form = form;
    this.confirm = confirm;
    this.resume = resume;
    this.abort = false;
  }
  Abort() {
    this.abort = true;
    return this.resume;
  }
}
class PaymentAfterSave {
  constructor(method, cpi) {
    this.method = method;
    this.cpi = cpi;
  }
}
class PaymentError extends Error {
  constructor(error) {
    super(error.message);
    this.error = error;
  }
}
const _c0$1 = ["recaptcha"];
const _c1$1 = [[["", "slot", "apm-readonly"]]];
const _c2 = ["[slot='apm-readonly']"];
const _c3 = (a0, a1, a2) => ({
  "w-100": a0,
  "btn-success": a1,
  "btn-secondary": a2
});
function PaymentDetailsComponent_form_0_option_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const apm_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", apm_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(apm_r1.apm_method);
  }
}
function PaymentDetailsComponent_form_0_ng_content_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "CustomerPaymentInfo.cpi_key !== null"]);
  }
}
function PaymentDetailsComponent_form_0_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "label", 15);
    i0.ɵɵtext(3, "Name on Card");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6)(6, "label", 17);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtext(8, "Card Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 18);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 19)(12, "div", 20)(13, "label", 21);
    i0.ɵɵpipe(14, "async");
    i0.ɵɵtext(15, "Expiration (mm/yyyy)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "input", 22);
    i0.ɵɵpipe(17, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 20)(19, "label", 23);
    i0.ɵɵpipe(20, "async");
    i0.ɵɵtext(21, "Security Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "input", 24);
    i0.ɵɵpipe(23, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const CustomerPaymentInfo_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵclassProp("text-danger", i0.ɵɵpipeBind1(7, 13, ctx_r2.cpi_temp_cc_number_error$));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-invalid", i0.ɵɵpipeBind1(10, 15, ctx_r2.cpi_temp_cc_number_error$));
    i0.ɵɵproperty("placeholder", CustomerPaymentInfo_r2.cpi_cc_number_display || "#### #### #### ####");
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("text-danger", i0.ɵɵpipeBind1(14, 17, ctx_r2.cpi_cc_expire_error$));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-invalid", i0.ɵɵpipeBind1(17, 19, ctx_r2.cpi_cc_expire_error$));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("text-danger", i0.ɵɵpipeBind1(20, 21, ctx_r2.cpi_cc_security_code_error$));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("is-invalid", i0.ɵɵpipeBind1(23, 23, ctx_r2.cpi_cc_security_code_error$));
  }
}
function PaymentDetailsComponent_form_0_ng_container_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "label", 25);
    i0.ɵɵtext(3, "Account Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "select", 26)(5, "option", 27);
    i0.ɵɵtext(6, "Checking");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "option", 28);
    i0.ɵɵtext(8, "Savings");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerStart(9);
    i0.ɵɵelementStart(10, "div", 6)(11, "label", 29);
    i0.ɵɵtext(12, "Name on Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 6)(15, "label", 31);
    i0.ɵɵtext(16, "Routing Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "input", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 6)(19, "label", 33);
    i0.ɵɵtext(20, "Account Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const CustomerPaymentInfo_r2 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(21);
    i0.ɵɵproperty("placeholder", CustomerPaymentInfo_r2.cpi_eft_account_number_display || "0123456879");
  }
}
function PaymentDetailsComponent_form_0_ng_container_24_div_13_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function PaymentDetailsComponent_form_0_ng_container_24_div_13_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.Close.emit());
    });
    i0.ɵɵtext(1, "Close");
    i0.ɵɵelementEnd();
  }
}
function PaymentDetailsComponent_form_0_ng_container_24_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PaymentDetailsComponent_form_0_ng_container_24_div_13_button_1_Template, 2, 0, "button", 41);
    i0.ɵɵelementStart(2, "button", 42);
    i0.ɵɵlistener("click", function PaymentDetailsComponent_form_0_ng_container_24_div_13_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.Save($event, false));
    });
    i0.ɵɵtext(3, "Save");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const status_r7 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.ShowClose);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c3, !ctx_r2.ShowClose, status_r7 === "VALID", status_r7 !== "VALID"))("disabled", status_r7 !== "VALID");
  }
}
function PaymentDetailsComponent_form_0_ng_container_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "input", 36);
    i0.ɵɵelementStart(3, "label", 37);
    i0.ɵɵtext(4, "Default payment method");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 38);
    i0.ɵɵtext(6, "Make this the default payment method for all auto-renewing and monthly payment memberships.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 6)(8, "label", 39);
    i0.ɵɵtext(9, "Security Check");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div")(11, "re-captcha", 40, 0);
    i0.ɵɵlistener("resolved", function PaymentDetailsComponent_form_0_ng_container_24_Template_re_captcha_resolved_11_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.recaptchResponse($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(13, PaymentDetailsComponent_form_0_ng_container_24_div_13_Template, 4, 7, "div", 11);
    i0.ɵɵpipe(14, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("siteKey", ctx_r2.siteKey);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 2, ctx_r2.Status$));
  }
}
function PaymentDetailsComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 2)(1, "fieldset", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "alert", 4)(4, "p", 5)(5, "em")(6, "strong");
    i0.ɵɵtext(7, "Please note:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " For your security, we ");
    i0.ɵɵelementStart(9, "strong");
    i0.ɵɵtext(10, "do not");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, " store your full credit card information (only the last 4 digits and expiration). Rather, our payment processor provides us with a secure, unique token that cannot be used by anyone else to charge your account.");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 6)(13, "label", 7);
    i0.ɵɵtext(14, "Payment Method");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "select", 8)(16, "option", 9);
    i0.ɵɵtext(17, "- Please Select -");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, PaymentDetailsComponent_form_0_option_18_Template, 2, 2, "option", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, PaymentDetailsComponent_form_0_ng_content_19_Template, 1, 0, "ng-content", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(20, 12);
    i0.ɵɵpipe(21, "async");
    i0.ɵɵtemplate(22, PaymentDetailsComponent_form_0_ng_container_22_Template, 24, 25, "ng-container", 13)(23, PaymentDetailsComponent_form_0_ng_container_23_Template, 22, 1, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(24, PaymentDetailsComponent_form_0_ng_container_24_Template, 15, 4, "ng-container", 11);
    i0.ɵɵpipe(25, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_7_0;
    let tmp_10_0;
    const CustomerPaymentInfo_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.Form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(2, 9, ctx_r2.Busy$));
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.PaymentMethods);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", CustomerPaymentInfo_r2.cpi_key !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", CustomerPaymentInfo_r2.apm_type || ((tmp_7_0 = i0.ɵɵpipeBind1(21, 11, ctx_r2.Form.get("PaymentMethod").valueChanges)) == null ? null : tmp_7_0.apm_type));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "credit card");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "ACH");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", CustomerPaymentInfo_r2.apm_type || ((tmp_10_0 = i0.ɵɵpipeBind1(25, 13, ctx_r2.Form.get("PaymentMethod").valueChanges)) == null ? null : tmp_10_0.apm_type));
  }
}
class PaymentDetailsComponent {
  set CustomerPaymentInfo(value) {
    this.CustomerPaymentInfo$.next(value);
  }
  set Action(value) {
    this.action$.next(value);
  }
  constructor(injector, settings) {
    this.injector = injector;
    this.action$ = new BehaviorSubject(undefined);
    this.CustomerPaymentInfo$ = new BehaviorSubject(undefined);
    this.ShowClose = false;
    this.Busy$ = new BehaviorSubject(false);
    this.Status$ = new BehaviorSubject(undefined);
    this.BeforeSave = new EventEmitter();
    this.AfterSave = new EventEmitter();
    this.Error = new EventEmitter();
    this.Close = new EventEmitter();
    this.cpi_temp_cc_number_error$ = new BehaviorSubject(false);
    this.cpi_cc_expire_error$ = new BehaviorSubject(false);
    this.cpi_cc_security_code_error$ = new BehaviorSubject(false);
    this.subsink = new SubSink();
    this.siteKey = settings.recaptcha_site_key;
  }
  ngOnInit() {
    if (!this.CustomPaymentService) {
      this.CustomPaymentService = this.injector.get(CustomerPaymentInfoService);
    }
    const defaults = {
      cpi_name_on_check: null,
      cpi_eft_routing_number: null,
      cpi_eft_account_type: null,
      cpi_cc_cardholder_name: null,
      cpi_cc_expire: null,
      cpi_preferred_flag: null
    };
    Object.assign(defaults, this.Defaults || {});
    const cpi_key = new UntypedFormControl(null, []);
    const PaymentMethod = new UntypedFormControl(null, [Validators.required]);
    // Check
    const cpi_name_on_check = new UntypedFormControl(defaults.cpi_name_on_check, []);
    const cpi_eft_routing_number = new UntypedFormControl(defaults.cpi_eft_routing_number, []);
    const cpi_eft_account_number = new UntypedFormControl(null, []);
    const cpi_eft_account_type = new UntypedFormControl(defaults.cpi_eft_account_type, []);
    // CC
    const cpi_cc_cardholder_name = new UntypedFormControl(defaults.cpi_cc_cardholder_name, []);
    const cpi_temp_cc_number = new UntypedFormControl(null, []);
    const cpi_cc_expire = new UntypedFormControl(defaults.cpi_cc_expire, []);
    const cpi_cc_security_code = new UntypedFormControl(null, []);
    const cpi_preferred_flag = new UntypedFormControl(defaults.cpi_preferred_flag, []);
    const recaptchResponse = new UntypedFormControl(null, [Validators.required]);
    console.log({
      defaults
    });
    this.Form = new UntypedFormGroup({
      cpi_key,
      PaymentMethod,
      recaptchResponse,
      // Check
      cpi_name_on_check,
      cpi_eft_routing_number,
      cpi_eft_account_number,
      cpi_eft_account_type,
      // CC
      cpi_cc_cardholder_name,
      cpi_temp_cc_number,
      cpi_cc_expire,
      cpi_cc_security_code,
      cpi_preferred_flag
    });
    this.subsink.sink = this.Form.statusChanges.subscribe(this.Status$);
    this.subsink.sink = cpi_temp_cc_number.statusChanges.subscribe(status => {
      if (status === 'INVALID') {
        this.cpi_temp_cc_number_error$.next(true);
      } else if (status === 'VALID') {
        this.cpi_temp_cc_number_error$.next(false);
      }
    });
    this.subsink.sink = cpi_cc_expire.statusChanges.subscribe(status => {
      if (status === 'INVALID') {
        this.cpi_cc_expire_error$.next(true);
      } else if (status === 'VALID') {
        this.cpi_cc_expire_error$.next(false);
      }
    });
    this.subsink.sink = cpi_cc_security_code.statusChanges.subscribe(status => {
      if (status === 'INVALID') {
        this.cpi_cc_security_code_error$.next(true);
      } else if (status === 'VALID') {
        this.cpi_cc_security_code_error$.next(false);
      }
    });
    this.subsink.sink = combineLatest([PaymentMethod.valueChanges, this.action$]).subscribe(([apm, action]) => {
      if (!apm) {
        cpi_eft_account_type.setValidators([]);
        cpi_name_on_check.setValidators([]);
        cpi_eft_routing_number.setValidators([]);
        cpi_eft_account_number.setValidators([]);
        cpi_cc_cardholder_name.setValidators([]);
        cpi_temp_cc_number.setValidators([]);
        cpi_cc_expire.setValidators([]);
        cpi_cc_security_code.setValidators([]);
      } else if (apm.apm_type === 'credit card') {
        if (action === 'Insert') {
          cpi_temp_cc_number.setValidators([Validators.required, Validators.pattern(/^[\d\-\s]{13,}$/)]);
          cpi_cc_security_code.enable();
          cpi_cc_security_code.setValidators([Validators.required, Validators.pattern(/^[\d]{3,4}$/)]);
        } else {
          cpi_temp_cc_number.setValidators([Validators.pattern(/^[\d\-\s]{13,}$/)]);
          cpi_cc_security_code.disable();
        }
        cpi_cc_cardholder_name.setValidators([Validators.required]);
        cpi_cc_expire.setValidators([Validators.required, Validators.pattern(/^([1-9]|0[1-9]|1[0-2])[\s]*\/[\s]*[\d]{4}$/)]);
        cpi_eft_account_type.setValidators([]);
        cpi_name_on_check.setValidators([]);
        cpi_eft_routing_number.setValidators([]);
        cpi_eft_account_number.setValidators([]);
      } else if (apm.apm_type === 'ACH') {
        if (action === 'Insert') {
          cpi_eft_account_number.setValidators([Validators.required]);
        }
        cpi_eft_account_type.setValidators([Validators.required]);
        cpi_name_on_check.setValidators([Validators.required]);
        cpi_eft_routing_number.setValidators([Validators.required]);
        cpi_cc_cardholder_name.setValidators([]);
        cpi_temp_cc_number.setValidators([]);
        cpi_cc_expire.setValidators([]);
        cpi_cc_security_code.setValidators([]);
      }
      cpi_eft_account_type.updateValueAndValidity();
      cpi_name_on_check.updateValueAndValidity();
      cpi_eft_account_number.updateValueAndValidity();
      cpi_eft_routing_number.updateValueAndValidity();
      cpi_cc_cardholder_name.updateValueAndValidity();
      cpi_temp_cc_number.updateValueAndValidity();
      cpi_cc_expire.updateValueAndValidity();
      cpi_cc_security_code.updateValueAndValidity();
    });
    let cpi_cc_security_code_require_validator = false;
    this.subsink.sink = combineLatest([cpi_temp_cc_number.valueChanges, this.action$]).subscribe(([cc, action]) => {
      if (action === 'Insert') {
        return;
      }
      if (cc && cc.length) {
        if (!cpi_cc_security_code_require_validator) {
          cpi_cc_security_code.enable();
          cpi_cc_security_code.setValidators([Validators.required, Validators.pattern(/^[\d]{3,4}$/)]);
          cpi_cc_security_code_require_validator = true;
          cpi_cc_security_code.updateValueAndValidity();
        }
      } else if (cpi_cc_security_code_require_validator) {
        cpi_cc_security_code_require_validator = false;
        cpi_cc_security_code.disable();
        cpi_cc_security_code.updateValueAndValidity();
      }
    });
    this.subsink.sink = this.CustomerPaymentInfo$.subscribe(cpi => {
      this.Form.reset({
        ...cpi,
        cpi_preferred_flag: defaults.cpi_preferred_flag,
        cpi_cc_expire: cpi.cpi_cc_expire ? formatDate(cpi.cpi_cc_expire, 'MM/yyyy', 'en-US') : null
      });
      if (cpi.cpi_apm_key) {
        PaymentMethod.reset(this.PaymentMethods.find(apm => apm.apm_key === cpi.cpi_apm_key));
        PaymentMethod.disable();
      } else {
        PaymentMethod.enable();
      }
    });
  }
  ngOnDestroy() {
    if (this.subsink) {
      this.subsink.unsubscribe();
    }
  }
  recaptchResponse(recaptchResponse) {
    this.Form.patchValue({
      recaptchResponse
    });
  }
  Save(event, confirm = false) {
    event.preventDefault();
    if (!this.Form.valid) {
      return;
    }
    const form = this.Form.getRawValue();
    const {
      recaptchResponse
    } = form;
    const OnBeforeSave = new PaymentBeforeSave(form, confirm, (event, confirm) => this.Save(event, confirm));
    this.BeforeSave.emit(OnBeforeSave);
    if (OnBeforeSave.abort) {
      return;
    }
    this.Busy$.next(true);
    let method;
    if (form.cpi_key) {
      method = 'Update';
    } else {
      method = 'Insert';
    }
    let update = {
      cpi_key: form.cpi_key,
      apm_key: form.PaymentMethod.apm_key,
      cpi_preferred_flag: form.cpi_preferred_flag
    };
    switch (form.PaymentMethod.apm_type) {
      case 'credit card':
        update = {
          ...update,
          cpi_cc_cardholder_name: form.cpi_cc_cardholder_name,
          cpi_cc_expire: form.cpi_cc_expire,
          cpi_cc_security_code: form.cpi_cc_security_code,
          cpi_temp_cc_number: form.cpi_temp_cc_number
        };
        break;
      case 'ACH':
        update = {
          ...update,
          cpi_name_on_check: form.cpi_name_on_check,
          cpi_eft_account_type: form.cpi_eft_account_type,
          cpi_eft_routing_number: form.cpi_eft_routing_number,
          cpi_eft_account_number: form.cpi_eft_account_number
        };
        break;
    }
    this.CustomPaymentService[method](update, recaptchResponse).subscribe({
      next: cpi => {
        const OnAfterSave = new PaymentAfterSave(method, cpi);
        this.AfterSave.emit(OnAfterSave);
        this.Busy$.next(false);
        this.recaptcha.reset();
      },
      error: err => {
        this.Error.emit(new PaymentError(err));
        this.Busy$.next(false);
        this.recaptcha.reset();
      }
    });
  }
  static {
    this.ɵfac = function PaymentDetailsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentDetailsComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(AppSettings));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PaymentDetailsComponent,
      selectors: [["pac-payment-details"]],
      viewQuery: function PaymentDetailsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0$1, 5, RecaptchaComponent);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.recaptcha = _t.first);
        }
      },
      inputs: {
        CustomerPaymentInfo: "CustomerPaymentInfo",
        Action: "Action",
        Defaults: "Defaults",
        PaymentMethods: "PaymentMethods",
        ShowClose: "ShowClose",
        CustomPaymentService: "CustomPaymentService"
      },
      outputs: {
        Busy$: "Busy$",
        Status$: "Status$",
        BeforeSave: "BeforeSave",
        AfterSave: "AfterSave",
        Error: "Error",
        Close: "Close"
      },
      ngContentSelectors: _c2,
      decls: 2,
      vars: 3,
      consts: [["recaptcha", "reCaptcha"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "disabled"], ["type", "info"], [1, "small"], [1, "mb-3"], ["for", "PaymentMethod", 1, "form-label"], ["id", "PaymentMethod", "name", "PaymentMethod", "formControlName", "PaymentMethod", 1, "form-select"], ["disabled", "", "value", "", 3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngValue"], ["for", "cpi_cc_cardholder_name", 1, "form-label"], ["type", "text", "id", "cpi_cc_cardholder_name", "placeholder", "jesse smith", "formControlName", "cpi_cc_cardholder_name", "data-private", "", 1, "form-control"], ["for", "cpi_temp_cc_number", 1, "form-label"], ["type", "text", "id", "cpi_temp_cc_number", "formControlName", "cpi_temp_cc_number", "data-private", "", 1, "form-control", 3, "placeholder"], [1, "row", "mb-3"], [1, "col-6"], ["for", "cpi_cc_expire", 1, "form-label"], ["type", "text", "id", "cpi_cc_expire", "pattern", "([1-9]|0[1-9]|1[0-2])[\\s]*\\/[\\s]*[\\d]{4}", "placeholder", "mm / yyyy", "formControlName", "cpi_cc_expire", "data-private", "", 1, "form-control"], ["for", "cpi_cc_security_code", 1, "form-label"], ["type", "text", "id", "cpi_cc_security_code", "placeholder", "###", "formControlName", "cpi_cc_security_code", "data-private", "", 1, "form-control"], ["for", "cpi_eft_account_type", 1, "form-label"], ["id", "cpi_eft_account_type", "formControlName", "cpi_eft_account_type", "data-private", "", 1, "form-select"], ["ngValue", "C"], ["ngValue", "S"], ["for", "cpi_name_on_check", 1, "form-label"], ["type", "text", "id", "cpi_name_on_check", "placeholder", "jesse smith", "formControlName", "cpi_name_on_check", "data-private", "", 1, "form-control"], ["for", "cpi_eft_routing_number", 1, "form-label"], ["type", "text", "id", "cpi_eft_routing_number", "placeholder", "0123456789", "formControlName", "cpi_eft_routing_number", "data-private", "", 1, "form-control"], ["for", "cpi_eft_account_number", 1, "form-label"], ["type", "text", "id", "cpi_eft_account_number", "formControlName", "cpi_eft_account_number", "data-private", "", 1, "form-control", 3, "placeholder"], [1, "mb-3", "form-check"], ["type", "checkbox", "id", "cpi_preferred_flag", "formControlName", "cpi_preferred_flag", 1, "form-check-input"], ["for", "cpi_preferred_flag", 1, "form-check-label"], [1, "small", "form-text", "text-muted"], [1, "form-label"], [3, "resolved", "siteKey"], ["type", "button", "class", "btn btn-lg mr-2 btn-light", 3, "click", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-lg", 3, "click", "ngClass", "disabled"], ["type", "button", 1, "btn", "btn-lg", "mr-2", "btn-light", 3, "click"]],
      template: function PaymentDetailsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c1$1);
          i0.ɵɵtemplate(0, PaymentDetailsComponent_form_0_Template, 26, 15, "form", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.CustomerPaymentInfo$));
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i3.ɵNgNoValidate, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.PatternValidator, i3.FormGroupDirective, i3.FormControlName, i4.AlertComponent, i5.RecaptchaComponent, i1$1.AsyncPipe],
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentDetailsComponent, [{
    type: Component,
    args: [{
      selector: 'pac-payment-details',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<form [formGroup]=\"Form\" *ngIf=\"CustomerPaymentInfo$ | async as CustomerPaymentInfo\">\r\n  <fieldset [disabled]=\"Busy$ | async\">\r\n    <alert type=\"info\">\r\n      <p class=\"small\"><em><strong>Please note:</strong> For your security, we <strong>do not</strong> store your full credit card information (only the last 4 digits and expiration). Rather, our payment processor provides us with a secure, unique token that cannot be used by anyone\r\n          else to charge your account.</em></p>\r\n    </alert>\r\n    <div class=\"mb-3\">\r\n      <label class=\"form-label\" for=\"PaymentMethod\">Payment Method</label>\r\n      <select id=\"PaymentMethod\" name=\"PaymentMethod\" class=\"form-select\" formControlName=\"PaymentMethod\">\r\n        <option disabled [ngValue]=\"null\" value=\"\">- Please Select -</option>\r\n        <option *ngFor=\"let apm of PaymentMethods\" [ngValue]=\"apm\">{{ apm.apm_method }}</option>\r\n      </select>\r\n      <ng-content *ngIf=\"CustomerPaymentInfo.cpi_key !== null\" select=\"[slot='apm-readonly']\"></ng-content>\r\n    </div>\r\n    <ng-container [ngSwitch]=\"CustomerPaymentInfo.apm_type || (Form.get('PaymentMethod').valueChanges | async)?.apm_type\">\r\n      <ng-container *ngSwitchCase=\"'credit card'\">\r\n        <div class=\"mb-3\">\r\n          <label class=\"form-label\" for=\"cpi_cc_cardholder_name\">Name on Card</label>\r\n          <input type=\"text\" class=\"form-control\" id=\"cpi_cc_cardholder_name\" placeholder=\"jesse smith\" formControlName=\"cpi_cc_cardholder_name\" data-private>\r\n        </div>\r\n        <div class=\"mb-3\">\r\n          <label class=\"form-label\" for=\"cpi_temp_cc_number\" [class.text-danger]=\"cpi_temp_cc_number_error$ | async\">Card Number</label>\r\n          <input type=\"text\" class=\"form-control\" [class.is-invalid]=\"cpi_temp_cc_number_error$ | async\" id=\"cpi_temp_cc_number\" [placeholder]=\"CustomerPaymentInfo.cpi_cc_number_display || '#### #### #### ####'\"\r\n            formControlName=\"cpi_temp_cc_number\" data-private>\r\n        </div>\r\n        <div class=\"row mb-3 \">\r\n          <div class=\"col-6\">\r\n            <label class=\"form-label\" for=\"cpi_cc_expire\" [class.text-danger]=\"cpi_cc_expire_error$ | async\">Expiration (mm/yyyy)</label>\r\n            <input type=\"text\" class=\"form-control\" [class.is-invalid]=\"cpi_cc_expire_error$ | async\" id=\"cpi_cc_expire\" pattern=\"([1-9]|0[1-9]|1[0-2])[\\s]*\\/[\\s]*[\\d]{4}\" placeholder=\"mm / yyyy\" formControlName=\"cpi_cc_expire\" data-private>\r\n          </div>\r\n          <div class=\"col-6\">\r\n            <label class=\"form-label\" for=\"cpi_cc_security_code\" [class.text-danger]=\"cpi_cc_security_code_error$ | async\">Security Code</label>\r\n            <input type=\"text\" class=\"form-control\" [class.is-invalid]=\"cpi_cc_security_code_error$ | async\" id=\"cpi_cc_security_code\" placeholder=\"###\" formControlName=\"cpi_cc_security_code\" data-private>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <ng-container *ngSwitchCase=\"'ACH'\">\r\n        <div class=\"mb-3\">\r\n          <label class=\"form-label\" for=\"cpi_eft_account_type\">Account Type</label>\r\n          <select id=\"cpi_eft_account_type\" class=\"form-select\" formControlName=\"cpi_eft_account_type\" data-private>\r\n            <option ngValue=\"C\">Checking</option>\r\n            <option ngValue=\"S\">Savings</option>\r\n          </select>\r\n        </div>\r\n        <ng-container>\r\n          <div class=\"mb-3\">\r\n            <label class=\"form-label\" for=\"cpi_name_on_check\">Name on Account</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"cpi_name_on_check\" placeholder=\"jesse smith\" formControlName=\"cpi_name_on_check\" data-private>\r\n          </div>\r\n          <div class=\"mb-3\">\r\n            <label class=\"form-label\" for=\"cpi_eft_routing_number\">Routing Number</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"cpi_eft_routing_number\" placeholder=\"0123456789\" formControlName=\"cpi_eft_routing_number\" data-private>\r\n          </div>\r\n          <div class=\"mb-3\">\r\n            <label class=\"form-label\" for=\"cpi_eft_account_number\">Account Number</label>\r\n            <input type=\"text\" class=\"form-control\" id=\"cpi_eft_account_number\" [placeholder]=\"CustomerPaymentInfo.cpi_eft_account_number_display || '0123456879'\" formControlName=\"cpi_eft_account_number\" data-private>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"CustomerPaymentInfo.apm_type || (Form.get('PaymentMethod').valueChanges | async)?.apm_type\">\r\n      <div class=\"mb-3 form-check\">\r\n        <input type=\"checkbox\" class=\"form-check-input\" id=\"cpi_preferred_flag\" formControlName=\"cpi_preferred_flag\">\r\n        <label class=\"form-check-label\" for=\"cpi_preferred_flag\">Default payment method</label>\r\n        <p class=\"small form-text text-muted\">Make this the default payment method for all auto-renewing and monthly\r\n          payment memberships.</p>\r\n      </div>\r\n\r\n      <div class=\"mb-3\">\r\n        <label class=\"form-label\">Security Check</label>\r\n        <div>\r\n          <re-captcha #recaptcha=\"reCaptcha\" (resolved)=\"recaptchResponse($event)\" [siteKey]=\"siteKey\"></re-captcha>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"(Status$ | async) as status\">\r\n        <button *ngIf=\"ShowClose\" type=\"button\" class=\"btn btn-lg mr-2 btn-light\" (click)=\"Close.emit()\">Close</button>\r\n\r\n        <button type=\"submit\" class=\"btn btn-lg\" [ngClass]=\"{ 'w-100': !ShowClose, 'btn-success': status === 'VALID', 'btn-secondary': status !== 'VALID' }\" [disabled]=\"status !== 'VALID'\" (click)=\"Save($event, false);\">Save</button>\r\n      </div>\r\n    </ng-container>\r\n  </fieldset>\r\n</form>\r\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: AppSettings
  }], {
    CustomerPaymentInfo: [{
      type: Input
    }],
    Action: [{
      type: Input
    }],
    Defaults: [{
      type: Input
    }],
    PaymentMethods: [{
      type: Input
    }],
    ShowClose: [{
      type: Input
    }],
    CustomPaymentService: [{
      type: Input
    }],
    Busy$: [{
      type: Output
    }],
    Status$: [{
      type: Output
    }],
    BeforeSave: [{
      type: Output
    }],
    AfterSave: [{
      type: Output
    }],
    Error: [{
      type: Output
    }],
    Close: [{
      type: Output
    }],
    recaptcha: [{
      type: ViewChild,
      args: ['recaptcha', {
        static: false,
        read: RecaptchaComponent
      }]
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentDetailsComponent, {
    className: "PaymentDetailsComponent",
    filePath: "lib\\components\\payment-details\\payment-details.component.ts",
    lineNumber: 21
  });
})();
const ccTest = new RegExp(/^[\d]{2}\*+([\d]{4})$/);
class CcDisplayPipe {
  transform(value) {
    if (value) {
      const match = ccTest.exec(value);
      if (match) {
        return '••••' + match[1];
      }
    }
    return value;
  }
  static {
    this.ɵfac = function CcDisplayPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CcDisplayPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "ccDisplay",
      type: CcDisplayPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CcDisplayPipe, [{
    type: Pipe,
    args: [{
      name: 'ccDisplay'
    }]
  }], null, null);
})();
const _c0 = ["*"];
const _c1 = a0 => ({
  "text-mbr_expire_date": a0
});
function PaymentInfoComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", ctx_r0.Info.apm_method, ") ");
  }
}
function PaymentInfoComponent_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Ex: ", i0.ɵɵpipeBind2(2, 1, ctx_r0.Info.cpi_cc_expire, "M/yy"), " ");
  }
}
function PaymentInfoComponent_ng_container_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 4)(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1, ctx_r0.mbr_expire_date && ctx_r0.Info.cpi_cc_expire <= ctx_r0.mbr_expire_date));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Ex:", i0.ɵɵpipeBind2(4, 3, ctx_r0.Info.cpi_cc_expire, "M/yy"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Ex: ", i0.ɵɵpipeBind2(7, 6, ctx_r0.Info.cpi_cc_expire, "M/yyyy"), "");
  }
}
function PaymentInfoComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PaymentInfoComponent_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ccDisplay");
    i0.ɵɵelementContainerStart(4, 0);
    i0.ɵɵtemplate(5, PaymentInfoComponent_ng_container_1_ng_container_5_Template, 3, 4, "ng-container", 1)(6, PaymentInfoComponent_ng_container_1_ng_container_6_Template, 8, 11, "ng-container", 3);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.ShowApm);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 4, ctx_r0.Info.cpi_cc_number_display), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r0.Plain);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", true);
  }
}
function PaymentInfoComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" (", ctx_r0.Info.cpi_eft_account_type === "S" ? "Savings" : "Checking", ") ", ctx_r0.Info.cpi_eft_account_number_display, " ");
  }
}
function PaymentInfoComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Credit or adjustment ");
    i0.ɵɵelementContainerEnd();
  }
}
class PaymentInfoComponent {
  set PaymentInfo(value) {
    if (typeof value !== 'object') {
      return;
    }
    if ('pin_cc_number_display' in value || 'pin_eft_account_number_display' in value) {
      this.Info = {
        cpi_key: value.pin_cpi_key,
        apm_key: value.pin_apm_key,
        apm_type: value.apm_type,
        apm_method: value.apm_method,
        cpi_cc_number_display: value.pin_cc_number_display,
        cpi_cc_expire: value.pin_cc_expire,
        cpi_eft_account_type: value.pin_eft_account_type,
        cpi_eft_account_number_display: value.pin_eft_account_number_display
      };
    } else {
      this.Info = {
        ...value
      };
    }
  }
  constructor() {
    this.mbr_expire_date = null;
    this.Plain = false;
    this.ShowApm = true;
  }
  ngOnInit() {}
  static {
    this.ɵfac = function PaymentInfoComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentInfoComponent)();
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: PaymentInfoComponent,
      selectors: [["pac-payment-info"]],
      inputs: {
        PaymentInfo: "PaymentInfo",
        mbr_expire_date: "mbr_expire_date",
        Plain: "Plain",
        ShowApm: "ShowApm"
      },
      ngContentSelectors: _c0,
      decls: 5,
      vars: 4,
      consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngIf"], [4, "ngSwitchDefault"], [3, "ngClass"], [1, "d-md-none"], [1, "d-none", "d-md-inline"]],
      template: function PaymentInfoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementContainerStart(0, 0);
          i0.ɵɵtemplate(1, PaymentInfoComponent_ng_container_1_Template, 7, 6, "ng-container", 1)(2, PaymentInfoComponent_ng_container_2_Template, 2, 2, "ng-container", 1)(3, PaymentInfoComponent_ng_container_3_Template, 2, 0, "ng-container", 1);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵprojection(4);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngSwitch", ctx.Info.apm_type);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "credit card");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "ACH");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "other");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$1.NgSwitchDefault, i1$1.DatePipe, CcDisplayPipe],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentInfoComponent, [{
    type: Component,
    args: [{
      selector: 'pac-payment-info',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<ng-container [ngSwitch]=\"Info.apm_type\">\r\n  <ng-container *ngSwitchCase=\"'credit card'\">\r\n    <ng-container *ngIf=\"ShowApm\">({{ Info.apm_method }}) </ng-container>{{ Info.cpi_cc_number_display | ccDisplay }}\r\n    <ng-container [ngSwitch]=\"Plain\">\r\n      <ng-container *ngSwitchCase=\"true\">\r\n        Ex: {{ Info.cpi_cc_expire | date:'M/yy' }}\r\n      </ng-container>\r\n      <ng-container *ngSwitchDefault>\r\n        <span [ngClass]=\"{ 'text-mbr_expire_date': mbr_expire_date && Info.cpi_cc_expire <= mbr_expire_date }\"><span class=\"d-md-none\">Ex:{{ Info.cpi_cc_expire | date:'M/yy' }}</span><span class=\"d-none d-md-inline\">Ex: {{ Info.cpi_cc_expire | date:'M/yyyy' }}</span></span>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'ACH'\">\r\n    ({{ Info.cpi_eft_account_type === 'S' ? 'Savings' : 'Checking' }}) {{ Info.cpi_eft_account_number_display }}\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'other'\">\r\n    Credit or adjustment\r\n  </ng-container>\r\n</ng-container>\r\n\r\n<ng-content></ng-content>\r\n"
    }]
  }], () => [], {
    PaymentInfo: [{
      type: Input
    }],
    mbr_expire_date: [{
      type: Input
    }],
    Plain: [{
      type: Input
    }],
    ShowApm: [{
      type: Input
    }]
  });
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaymentInfoComponent, {
    className: "PaymentInfoComponent",
    filePath: "lib\\components\\payment-info\\payment-info.component.ts",
    lineNumber: 12
  });
})();
class SiteMailComponent {
  constructor(settings) {
    this.settings = settings;
    this.site_mail = this.settings.site_mail;
  }
  static {
    this.ɵfac = function SiteMailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteMailComponent)(i0.ɵɵdirectiveInject(AppSettings));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SiteMailComponent,
      selectors: [["pac-site-mail"]],
      decls: 2,
      vars: 3,
      consts: [[3, "href"]],
      template: function SiteMailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx.site_mail, "", i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.site_mail);
        }
      },
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteMailComponent, [{
    type: Component,
    args: [{
      selector: 'pac-site-mail',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<a href=\"mailto:{{ site_mail }}\">{{ site_mail }}</a>\r\n"
    }]
  }], () => [{
    type: AppSettings
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SiteMailComponent, {
    className: "SiteMailComponent",
    filePath: "lib\\components\\site-mail\\site-mail.component.ts",
    lineNumber: 10
  });
})();
class SitePhoneComponent {
  constructor(settings) {
    this.settings = settings;
    this.site_phone = this.settings.site_phone;
  }
  static {
    this.ɵfac = function SitePhoneComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SitePhoneComponent)(i0.ɵɵdirectiveInject(AppSettings));
    };
  }
  static {
    this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
      type: SitePhoneComponent,
      selectors: [["pac-site-phone"]],
      decls: 2,
      vars: 3,
      consts: [[3, "href"]],
      template: function SitePhoneComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtext(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate1("href", "tel:", ctx.site_phone, "", i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.site_phone);
        }
      },
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SitePhoneComponent, [{
    type: Component,
    args: [{
      selector: 'pac-site-phone',
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<a href=\"tel:{{ site_phone }}\">{{ site_phone }}</a>\r\n"
    }]
  }], () => [{
    type: AppSettings
  }], null);
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SitePhoneComponent, {
    className: "SitePhoneComponent",
    filePath: "lib\\components\\site-phone\\site-phone.component.ts",
    lineNumber: 10
  });
})();
const BootstrapVersion = new InjectionToken("BootstrapVersion");
class BsClassDirective {
  set bs3Class(values) {
    if (this.bsVersion === 'bs3') {
      this.klassNames.push(...values);
      this.applyClasses(values);
    }
  }
  set bs4Class(values) {
    if (this.bsVersion === 'bs4' || this.bsVersion == 'bs5') {
      this.klassNames.push(...values);
      this.applyClasses(values);
    }
  }
  set bs5Class(values) {
    if (this.bsVersion === 'bs5') {
      this.klassNames.push(...values);
      this.applyClasses(values);
    }
  }
  constructor(element, renderer, bsVersion) {
    this.element = element;
    this.renderer = renderer;
    this.bsVersion = bsVersion;
    this.klassNames = [];
  }
  applyClasses(klasses) {
    klasses.forEach(klass => this.toggleClass(klass, true));
  }
  toggleClass(klass, enabled) {
    klass = klass.trim();
    if (klass) {
      klass.split(/\s+/g).forEach(klass => {
        if (enabled) {
          this.renderer.addClass(this.element.nativeElement, klass);
        } else {
          this.renderer.removeClass(this.element.nativeElement, klass);
        }
      });
    }
  }
  static {
    this.ɵfac = function BsClassDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BsClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BootstrapVersion));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: BsClassDirective,
      selectors: [["", "bs3Class", ""], ["", "bs4Class", ""], ["", "bs5Class", ""]],
      inputs: {
        bs3Class: "bs3Class",
        bs4Class: "bs4Class",
        bs5Class: "bs5Class"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BsClassDirective, [{
    type: Directive,
    args: [{
      selector: '[bs3Class],[bs4Class],[bs5Class]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [BootstrapVersion]
    }]
  }], {
    bs3Class: [{
      type: Input
    }],
    bs4Class: [{
      type: Input
    }],
    bs5Class: [{
      type: Input
    }]
  });
})();
class BsMigrationPickerDirective {
  constructor(viewContainer, bsVer) {
    this.viewContainer = viewContainer;
    this.bsVer = bsVer;
    this.bs3 = null;
    this.bs4 = null;
    this.bs5 = null;
  }
  ngOnInit() {
    if (this.bsVer == 'bs3') {
      if (this.bs3) {
        this.viewContainer.createEmbeddedView(this.bs3);
      }
    } else if (this.bsVer == 'bs4' || this.bsVer == 'bs5' && this.bs5 == null) {
      if (this.bs4) {
        this.viewContainer.createEmbeddedView(this.bs4);
      }
    } else if (this.bsVer == 'bs5') {
      if (this.bs5) {
        this.viewContainer.createEmbeddedView(this.bs5);
      }
    }
  }
  static {
    this.ɵfac = function BsMigrationPickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BsMigrationPickerDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(BootstrapVersion));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: BsMigrationPickerDirective,
      selectors: [["ng-container", "bsMigrationPicker", ""]],
      inputs: {
        bs3: "bs3",
        bs4: "bs4",
        bs5: "bs5"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BsMigrationPickerDirective, [{
    type: Directive,
    args: [{
      selector: 'ng-container[bsMigrationPicker]'
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [BootstrapVersion]
    }]
  }], {
    bs3: [{
      type: Input
    }],
    bs4: [{
      type: Input
    }],
    bs5: [{
      type: Input
    }]
  });
})();
var bsClassMap = [{
  bs3: "panel",
  bs4: "card"
}, {
  bs3: "panel-heading",
  bs4: "card-header"
}, {
  bs3: "panel-body",
  bs4: "card-body"
}, {
  bs3: "panel-footer",
  bs4: "card-footer"
}, {
  bs3: "text-left",
  bs4: "text-start"
}, {
  bs3: "text-right",
  bs4: "text-end"
}, {
  bs3: "col-xs-3",
  bs4: "col-3"
}, {
  bs3: "col-xs-5",
  bs4: "col-5"
}, {
  bs3: "col-xs-6",
  bs4: "col-6"
}, {
  bs3: "col-xs-7",
  bs4: "col-7"
}, {
  bs3: "col-xs-12",
  bs4: "col-12"
}, {
  bs3: "btn-default",
  bs4: "btn-light"
}, {
  bs3: "input-group-addon",
  bs4: "input-group-text"
}, {
  bs3: "pull-left",
  bs4: "float-start"
}, {
  bs3: "pull-right",
  bs4: "float-end"
}, {
  bs3: "checkbox",
  bs4: "form-check"
}, {
  bs3: "radio",
  bs4: "form-radio"
}];
class BootstrapClassMapperService {
  constructor(bsVersion) {
    this.bsVersion = bsVersion;
    this.bsClassMap = bsClassMap;
    this.bs3to5 = new Map();
    this.bs5to3 = new Map();
    for (const map of this.bsClassMap) {
      if ('bs5' in map) {
        this.bs3to5.set(map.bs3, map.bs5);
        this.bs5to3.set(map.bs5, map.bs3);
      } else if ('bs4' in map) {
        this.bs3to5.set(map.bs3, map.bs4);
        this.bs5to3.set(map.bs4, map.bs3);
      }
    }
  }
  MapClass(className) {
    if (this.bsVersion === 'bs3') {
      return this.bs5to3.get(className) || className;
    } else {
      return this.bs3to5.get(className) || className;
    }
  }
  MapClasses(classNames) {
    if (this.bsVersion === 'bs3') {
      return classNames.map(className => this.bs5to3.get(className) || className);
    } else {
      return classNames.map(className => this.bs3to5.get(className) || className);
    }
  }
  static {
    this.ɵfac = function BootstrapClassMapperService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BootstrapClassMapperService)(i0.ɵɵinject(BootstrapVersion));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: BootstrapClassMapperService,
      factory: BootstrapClassMapperService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BootstrapClassMapperService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [BootstrapVersion]
    }]
  }], null);
})();
class BsMigrationDirective {
  set klass(value) {
    const values = typeof value === 'string' ? value.split(/\s+/) : [];
    this.removeClasses(this.classNames);
    this.classNames = values;
    this.applyClasses(values);
  }
  constructor(element, renderer, bsClassMapper, bsVersion) {
    this.element = element;
    this.renderer = renderer;
    this.bsClassMapper = bsClassMapper;
    this.bsVersion = bsVersion;
    this.classNames = [];
  }
  applyClasses(rawClassVal) {
    const mappedClasses = this.bsClassMapper.MapClasses(rawClassVal);
    const remove = rawClassVal.filter(c => !mappedClasses.includes(c));
    mappedClasses.forEach(klass => this.toggleClass(klass, true));
    this.removeClasses(remove);
  }
  removeClasses(rawClassVal) {
    rawClassVal.forEach(klass => this.toggleClass(klass, false));
  }
  toggleClass(klass, enabled) {
    klass = klass.trim();
    if (klass) {
      klass.split(/\s+/g).forEach(klass => {
        if (enabled) {
          this.renderer.addClass(this.element.nativeElement, klass);
        } else {
          this.renderer.removeClass(this.element.nativeElement, klass);
        }
      });
    }
  }
  static {
    this.ɵfac = function BsMigrationDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BsMigrationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BootstrapClassMapperService), i0.ɵɵdirectiveInject(BootstrapVersion));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: BsMigrationDirective,
      selectors: [["", "bsMigration", ""]],
      inputs: {
        klass: [0, "class", "klass"]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BsMigrationDirective, [{
    type: Directive,
    args: [{
      selector: '[bsMigration]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: BootstrapClassMapperService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [BootstrapVersion]
    }]
  }], {
    klass: [{
      type: Input,
      args: ['class']
    }]
  });
})();
const DrupalVersion = new InjectionToken("DrupalVersion");
const HeaderDefaultDestination = new InjectionToken('HeaderDefaultDestination', {
  factory: () => null
});
class HeaderDirective {
  set header(title) {
    this.setTitle(title);
  }
  set headerD7(value) {
    if (this.drupalVer == 'd7') {
      this._dirty = true;
      this._dest = value;
    }
  }
  set headerD9(value) {
    if (this.drupalVer == 'd9') {
      this._dirty = true;
      this._dest = value;
    }
  }
  constructor(templateRef, viewContainer, title, doc, renderer, drupalVer, defaultDest) {
    this.templateRef = templateRef;
    this.viewContainer = viewContainer;
    this.title = title;
    this.doc = doc;
    this.renderer = renderer;
    this.drupalVer = drupalVer;
    this.defaultDest = defaultDest;
    this._title = null;
    this._dirty = false;
    this._dest = null;
  }
  ngOnInit() {
    if (this.defaultDest && this._dest === null) {
      this._dest = this.defaultDest;
    }
  }
  setTitle(title) {
    this._dirty = true;
    this._title = title;
    this.title.setTitle(title);
  }
  getTitle() {
    return this._title;
  }
  ngDoCheck() {
    if (this._dirty) {
      this._dirty = false;
      this.viewContainer.clear();
      let dest = this._dest;
      if (typeof dest === 'string') {
        const element = this.doc.querySelector(dest);
        if (element) {
          const text = this.renderer.createText(this._title);
          element.replaceChildren(text);
        }
      } else if (dest instanceof TemplateRef) {
        this.viewContainer.createEmbeddedView(dest, {
          $implicit: this._title
        });
      } else {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: this._title
        });
      }
    }
  }
  static {
    this.ɵfac = function HeaderDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HeaderDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2.Title), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DrupalVersion), i0.ɵɵdirectiveInject(HeaderDefaultDestination));
    };
  }
  static {
    this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
      type: HeaderDirective,
      selectors: [["", "header", ""]],
      inputs: {
        header: "header",
        headerD7: "headerD7",
        headerD9: "headerD9"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderDirective, [{
    type: Directive,
    args: [{
      selector: '[header]'
    }]
  }], () => [{
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i2.Title
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DrupalVersion]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [HeaderDefaultDestination]
    }]
  }], {
    header: [{
      type: Input
    }],
    headerD7: [{
      type: Input
    }],
    headerD9: [{
      type: Input
    }]
  });
})();
class CxaMailingPipe {
  transform(value, count = null) {
    if (!value) return '';
    const parts = value.split('\n').map(part => part.trim()).filter(part => part !== '');
    parts.shift();
    if (count && count > 1) {
      for (var i = 1; i < count; i++) {
        parts.shift();
      }
    }
    return parts.join(', ');
  }
  static {
    this.ɵfac = function CxaMailingPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CxaMailingPipe)();
    };
  }
  static {
    this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
      name: "cxaMailing",
      type: CxaMailingPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CxaMailingPipe, [{
    type: Pipe,
    args: [{
      name: 'cxaMailing'
    }]
  }], null, null);
})();
const INDIVIDUAL = new InjectionToken("INDIVIDUAL");
class Individual {
  constructor(source) {
    this.ind_first_name = undefined;
    this.ind_mid_name = undefined;
    this.ind_last_name = undefined;
    this.ind_badge_name = undefined;
    this.ind_full_name_cp = undefined;
    this.ind_dob = undefined;
    this.ind_gender = undefined;
    this.ind_yes_hot_stone_practice_flag_ext = undefined;
    this.ind_yes_hot_stone_practice_date_ext = undefined;
    this.ind_no_hot_stone_practice_flag_ext = undefined;
    this.ind_no_hot_stone_practice_date_ext = undefined;
    this.ind_hot_stone_do_not_agree_flag_ext = undefined;
    this.ind_hot_stone_do_not_agree_date_ext = undefined;
    this.ind_hot_stone_agreement_flag_ext = undefined;
    this.ind_hot_stone_agreement_date_ext = undefined;
    this.ind_hot_stone_video_flag_ext = undefined;
    this.ind_hot_stone_video_date_ext = undefined;
    this.ind_hot_stone_video_do_not_agree_flag_ext = undefined;
    this.ind_hot_stone_video_do_not_agree_date_ext = undefined;
    this.ind_mblex_date_ext = undefined;
    this.cst_key = undefined;
    this.cst_recno = undefined;
    this.cst_new_password = undefined;
    this.cst_new_password_confirm = undefined;
    this.cst_org_name_dn = undefined;
    this.cst_member_flag = undefined;
    this.cxa_key = undefined;
    this.cst_cxa_billing_key = undefined;
    this.cxa_mailing_label = undefined;
    this.cxa_on_hold_flag = undefined;
    this.cst_phn_number_complete_dn = undefined;
    this.phn_number = undefined;
    this.eml_address = undefined;
    this.adr_line1 = undefined;
    this.adr_city = undefined;
    this.adr_state = undefined;
    this.adr_post_code = undefined;
    this.adr_country = undefined;
    this.ind_token = undefined;
    // Referral / Affinity columns
    this.cst_src_key = undefined;
    this.cst_src_option_select_ext = undefined;
    this.cst_src_referral_member_first_name_ext = undefined;
    this.cst_src_referral_member_last_name_ext = undefined;
    this.cst_src_referral_cst_recno_ext = undefined;
    this.cst_src_specify_other_ext = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ind_dob':
              if (source[key] === null || source[key] === undefined || source[key] === '') {
                this[key] = null;
              } else {
                const parts = source[key].split('/');
                if (parts.length === 3) {
                  const nParts = parts.map(part => parseInt(part));
                  this[key] = new Date(nParts[2], nParts[0] - 1, nParts[1]);
                }
              }
              break;
            case 'ind_yes_hot_stone_practice_date_ext':
            case 'ind_no_hot_stone_practice_date_ext':
            case 'ind_hot_stone_agreement_date_ext':
            case 'ind_hot_stone_video_date_ext':
            case 'ind_mblex_date_ext':
              if (source[key] === null || source[key] === undefined || source[key] === '') {
                this[key] = null;
              } else {
                const date = moment(source[key].date ?? source[key]);
                this[key] = date.toDate();
              }
              break;
            case 'cst_recno':
            case 'cst_src_referral_cst_recno_ext':
              const cst_recno = source[key] || null;
              const k = key;
              if (cst_recno) {
                this[k] = parseInt(cst_recno, 10) || null;
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class Note {
  constructor(source) {
    this.not_key = undefined;
    this.not_cst_key = undefined;
    this.not_subject = undefined;
    this.not_note = undefined;
    this.not_priority = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class LoginResult {}
class IndividualService {
  constructor(http, router, settings, individual) {
    this.http = http;
    this.router = router;
    this.individual$ = new ReplaySubject(1);
    this.Individual$ = this.individual$.asObservable();
    this.endpoint = settings.pac_base_nf_url + 'api/Individual';
    if (individual && 'cst_key' in individual && individual.cst_key) {
      this.individual$.next(new Individual(individual));
      this.loggedIn$ = new BehaviorSubject(true);
      // If from Login API, and less than 5min old, don't refresh
      if ('update' in individual && individual.update) {
        const now = new Date().valueOf() / 1000;
        if (individual.update < now - 300) {
          this.Update(individual).pipe(take(1)).subscribe();
        }
      }
    } else {
      this.loggedIn$ = new BehaviorSubject(false);
    }
    this.LoggedIn$ = this.loggedIn$.asObservable();
  }
  Refresh(individual = null) {
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError((err, caught) => {
      if (individual) {
        return this.http.get(`/pac-wizard/login/${individual.eml_address}`, {
          withCredentials: true
        }).pipe(map(result => {
          if ('status' in result && result.status && 'individual' in result && result.individual) {
            return result.individual;
          }
          return undefined;
        }));
      }
      throw err;
    }), catchError(ApiErrorHandler), map(result => {
      if (result && 'cst_recno' in result) {
        individual = result;
        return new Individual(result);
      }
      throw new Error('Unknown response from server');
    }), tap({
      error: LoginExceptionRedirect
    }), filter(individual => individual instanceof Individual), tap({
      next: individual => this.individual$.next(individual),
      error: error => {
        if (error instanceof ApiError) {
          if (error.code === ApiErrors.LoginRequired) {
            this.router.navigate(['/login']);
            return;
          }
        }
        this.individual$.error(error);
      }
    }));
    ;
  }
  Login(username, password) {
    const data = new FormData();
    data.append('password', password);
    return this.http.post(`/pac-wizard/login/${username}`, data, {
      withCredentials: true
    }).pipe(map(result => {
      if (result && 'individual' in result) {
        const individual = new Individual(result.individual);
        this.individual$.next(individual);
        this.loggedIn$.next(true);
        return individual;
      }
      if (result && 'status' in result && result.status === false) {
        if (result.error) {
          throw result.error;
        }
        if (result.warning) {
          throw result.warning;
        }
      }
      return null;
    }));
  }
  Update(update) {
    return this.http.put(this.endpoint, update, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), switchMap(result => {
      if (result && 'cst_recno' in result) {
        return this.http.post(`/pac-wizard/login/${result.eml_address}`, update, {
          withCredentials: true
        });
      }
      throw new Error('Unknown response from server');
    }), map(result => {
      if (result && 'individual' in result && 'cst_recno' in result.individual) {
        return new Individual(result.individual);
      }
      throw new Error('Unknown response from server');
    }), tap({
      next: individual => this.individual$.next(individual),
      error: error => {
        if (error instanceof Error) {
          this.individual$.error(error);
        }
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  AddNote(note) {
    return this.http.post(this.endpoint + '/AddNote', note, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'not_key' in result) {
        return new Note(result);
      }
      throw new Error('Unknown response from server');
    }));
  }
  static {
    this.ɵfac = function IndividualService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IndividualService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(AppSettings), i0.ɵɵinject(INDIVIDUAL));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: IndividualService,
      factory: IndividualService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IndividualService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2$1.Router
  }, {
    type: AppSettings
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [INDIVIDUAL]
    }]
  }], null);
})();
class IndividualResolver {
  constructor(individualService) {
    this.individualService = individualService;
  }
  resolve(route, state) {
    return this.individualService.Individual$.pipe(take(1));
  }
  static {
    this.ɵfac = function IndividualResolver_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IndividualResolver)(i0.ɵɵinject(IndividualService));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: IndividualResolver,
      factory: IndividualResolver.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IndividualResolver, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: IndividualService
  }], null);
})();
class IndividualAddress {
  constructor(source) {
    this.cxa_key = undefined;
    this.cxa_cst_key = undefined;
    this.cxa_on_hold_flag = undefined;
    this.cxa_primary = undefined;
    this.cxa_billing = undefined;
    this.cxa_mailing_label = undefined;
    this.cxa_adt_key = undefined;
    this.adt_code = undefined;
    this.adr_key = undefined;
    this.adr_line1 = undefined;
    this.adr_line2 = undefined;
    this.adr_city = undefined;
    this.adr_county = undefined;
    this.adr_state = undefined;
    this.adr_post_code = undefined;
    this.adr_intl_province = undefined;
    this.adr_latitude = undefined;
    this.adr_longitude = undefined;
    this.adr_cong_dist = undefined;
    this.adr_carrier_route = undefined;
    this.adr_fips = undefined;
    this.adr_time_zone = undefined;
    this.adr_delivery_point_code = undefined;
    this.adr_mailing_label = undefined;
    this.adr_country = undefined;
    this.adr_country = 'UNITED STATES';
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class AddressService {
  get CustomerAddress$() {
    if (!this.customerAddress$) {
      this.Get();
    }
    return this.customerAddress$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.reset = false;
    this.endpoint = settings.pac_base_nf_url + 'api/Address';
    this.labelEndpoint = settings.pac_base_nf_url + 'api/Helper/co_country_mailing_label_format_select/';
    this.formatEndpoint = '/pac-wizard/country/';
    this.mailingLabelFormat$ = new Map();
    this.addressFormat$ = new Map();
  }
  Get(cached = true) {
    if (cached && this.customerAddress$ && this.reset === false) {
      return this.CustomerAddress$;
    }
    if (!this.customerAddress$) {
      this.customerAddress$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(adr => new IndividualAddress(adr));
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.reset = false;
        this.customerAddress$.next(results);
      }
    });
    return this.CustomerAddress$;
  }
  GetMailingLabelFormat(country) {
    if (this.mailingLabelFormat$.has(country)) {
      return this.mailingLabelFormat$.get(country);
    }
    const mailingLabelFormat$ = new BehaviorSubject(undefined);
    this.mailingLabelFormat$.set(country, mailingLabelFormat$.asObservable().pipe(filter(format => format !== undefined)));
    this.http.get(this.labelEndpoint + country, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (typeof result === 'string') {
        return result.split('\r\n').map(line => line.trim());
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(result => {
      if (result instanceof Array) {
        mailingLabelFormat$.next(result);
      }
    });
    return this.mailingLabelFormat$.get(country);
  }
  GetAddressFormat$(country) {
    if (this.addressFormat$.has(country)) {
      return this.addressFormat$.get(country);
    }
    const addressFormat$ = new BehaviorSubject(undefined);
    this.addressFormat$.set(country, addressFormat$.asObservable().pipe(filter(format => format !== undefined)));
    this.http.get(this.formatEndpoint + country, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if ('administrative_areas' in result) {
        return result;
      }
      return null;
    })).subscribe(result => {
      if (result) {
        addressFormat$.next(result);
      }
    });
    return this.addressFormat$.get(country);
  }
  Reset() {
    this.reset = true;
  }
  Validate(adr) {
    return this.http.patch(this.endpoint, adr, {
      withCredentials: true
    }).pipe(catchError((err, caught) => {
      if (err.status === 404) {
        throw new Error('Could not validate address. Please verify all information is correct. If the issue persists, please check "Do not validate address".');
      }
      return ApiErrorHandler(err, caught);
    }), map(result => {
      if (result && ('adr_key' in result || 'adr_line1' in result || 'adr_country' in result)) {
        return result;
      }
      return null;
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Update(adr) {
    return this.http.put(this.endpoint + '/' + adr.cxa_key, adr, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cxa_key' in result) {
        return new IndividualAddress(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof IndividualAddress) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Insert(adr) {
    return this.http.post(this.endpoint, adr, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cxa_key' in result) {
        return new IndividualAddress(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof IndividualAddress) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function AddressService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: AddressService,
      factory: AddressService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class AieService {
  get AIE$() {
    return this.aie$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.aie$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/PACAIE';
  }
  Get() {
    if (this.aie$) {
      return this.AIE$;
    }
    if (this.aie$ === null) {
      this.aie$ = new ReplaySubject(1);
    }
    this.Refresh().subscribe(results => {
      if (results instanceof Array) {
        this.aie$.next(results);
      }
    });
    return this.AIE$;
  }
  Insert(aie) {
    if (this.aie$ === null) {
      this.aie$ = new ReplaySubject(1);
    }
    return this.http.post(this.endpoint, aie, {
      withCredentials: true
    }).pipe(switchMap(result => this.Refresh().pipe(map(list => [result, list]))), map(([result, list]) => {
      if (list instanceof Array) {
        this.aie$.next(list);
      }
      if ('p10_key' in result) {
        return result;
      }
      return null;
    }), take(1));
  }
  Delete(aie) {
    if (this.aie$ === null) {
      this.aie$ = new ReplaySubject(1);
    }
    return this.http.delete(this.endpoint + '/' + aie.p10_key, {
      withCredentials: true
    }).pipe(switchMap(() => this.Refresh()), tap(results => {
      if (results instanceof Array) {
        this.aie$.next(results);
      }
    }), mapTo(null), take(1));
  }
  Refresh() {
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(p10 => {
          const p10_start_date = p10.p10_start_date ? moment(p10.p10_start_date).toDate() : null,
            p10_end_date = p10.p10_end_date ? moment(p10.p10_end_date).toDate() : null;
          return {
            ...p10,
            p10_start_date,
            p10_end_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function AieService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AieService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: AieService,
      factory: AieService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AieService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
const AsnOrder = {
  ABMP: 1,
  ASCP: 2,
  AHP: 3,
  ANP: 4
};
const Assoications = ['ABMP', 'ASCP', 'AHP', 'ANP'];
;
;
function AsnSort(a, b) {
  if ('mbr_asn_code' in a && 'mbr_asn_code' in b) {
    return AsnOrder[a.mbr_asn_code] - AsnOrder[b.mbr_asn_code];
  }
  if ('Asn' in a && 'Asn' in b) {
    return AsnOrder[a.Asn] - AsnOrder[b.Asn];
  }
  return 0;
}
const AsnLogo = {
  ABMP: '/members/my-membership/assets/abmp.png',
  ASCP: '/members/my-membership/assets/ascp.svg',
  AHP: '/members/my-membership/assets/ahp.svg',
  ANP: 'https://www.nailprofessional.com/sites/nailprofessional.com/themes/anp/logo.png'
};
class AssociationService {
  get Asn() {
    return this.asn;
  }
  constructor(settings) {
    this.asn = settings.pac_base_asn_code;
  }
  static {
    this.ɵfac = function AssociationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AssociationService)(i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: AssociationService,
      factory: AssociationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AssociationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: AppSettings
  }], null);
})();
class ComplianceDetailService {
  get ComplianceDetails$() {
    return this.complianceDetails$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.complianceDetails$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/PACInsuranceComplianceDetail';
  }
  Get() {
    if (this.complianceDetails$) {
      return this.ComplianceDetails$;
    }
    if (this.complianceDetails$ === null) {
      this.complianceDetails$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(p03 => {
          const p03_insured_start_date = p03.p03_insured_start_date ? moment(p03.p03_insured_start_date).toDate() : null,
            p03_insured_expire_date = p03.p03_insured_expire_date ? moment(p03.p03_insured_expire_date).toDate() : null,
            p03_membership_agreement_date = p03.p03_membership_agreement_date ? moment(p03.p03_membership_agreement_date).toDate() : null;
          return {
            ...p03,
            p03_membership_agreement_date,
            p03_insured_start_date,
            p03_insured_expire_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.complianceDetails$.next(results);
      }
    });
    return this.ComplianceDetails$;
  }
  static {
    this.ɵfac = function ComplianceDetailService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComplianceDetailService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: ComplianceDetailService,
      factory: ComplianceDetailService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplianceDetailService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
;
class GoogleTagManagerService {
  constructor(window) {
    this.window = window;
    this.window.dataLayer = this.window.dataLayer || [];
  }
  push(tag) {
    this.window.dataLayer.push(tag);
  }
  static {
    this.ɵfac = function GoogleTagManagerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GoogleTagManagerService)(i0.ɵɵinject(WindowToken));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: GoogleTagManagerService,
      factory: GoogleTagManagerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WindowToken]
    }]
  }], null);
})();
class IndividualAffiliation {
  constructor(source) {
    this.IsAffinity = [];
    this.ixo_key = undefined;
    this.ixo_start_date = undefined;
    this.ixo_end_date = undefined;
    this.ixo_add_date = undefined;
    this.ixo_title = undefined;
    this.ixo_primary_affinity_flag_ext = undefined;
    this.rlt_code = undefined;
    this.rlt_flow_down = undefined;
    this.rlt_org_area_access_flag = undefined;
    this.rlt_org_area_access_edit_flag = undefined;
    this.cst_recno = undefined;
    this.org_name = undefined;
    this.org_ogt_code = undefined;
    this.org_group_aie_flag_ext = undefined;
    this.org_require_aie_flag_ext = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ixo_start_date':
            case 'ixo_end_date':
            case 'ixo_add_date':
              const dateKey = key;
              if (source[dateKey] == null || source[dateKey] === undefined || source[dateKey] === '') {
                this[dateKey] = null;
              } else {
                this[dateKey] = new Date(source[dateKey]);
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class IndividualAffiliationService {
  constructor(http, settings) {
    this.http = http;
    this.affiliation$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/IndividualAffiliation';
  }
  Get(cache = true) {
    if (cache && this.affiliation$) {
      return this.affiliation$;
    }
    if (this.affiliation$ === null) {
      this.affiliation$ = new ReplaySubject(1);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError$1(ApiErrorHandler), map$1(result => result.map(ixo => new IndividualAffiliation(ixo))), take$1(1)).subscribe({
      next: result => {
        this.affiliation$.next(result);
      }
    });
    return this.affiliation$;
  }
  static {
    this.ɵfac = function IndividualAffiliationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IndividualAffiliationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: IndividualAffiliationService,
      factory: IndividualAffiliationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IndividualAffiliationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class MembershipRenewalsProcessService {
  get Mdr$() {
    return this.mdr$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.mdr$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/MembershipDuesRenewalProcess';
  }
  Get() {
    if (this.mdr$) {
      return this.Mdr$;
    }
    if (this.mdr$ === null) {
      this.mdr$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(mdr => {
          const mdr_trx_date = mdr.mdr_trx_date ? moment(mdr.mdr_trx_date).toDate() : null;
          return {
            ...mdr,
            mdr_trx_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.mdr$.next(results);
      }
    });
    return this.Mdr$;
  }
  static {
    this.ɵfac = function MembershipRenewalsProcessService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MembershipRenewalsProcessService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: MembershipRenewalsProcessService,
      factory: MembershipRenewalsProcessService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MembershipRenewalsProcessService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class LicenseInfo {
  constructor(source) {
    this.State = undefined;
    this.Number = undefined;
    this.Exempt = undefined;
    this.Raw = undefined;
    this.Prefix = undefined;
    this.Computed = undefined;
    this.Expire = undefined;
    this.StateExempt = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          if (key === 'Expire') {
            this.Expire = source[key] == null ? null : new Date(source[key]);
          } else {
            this[key] = source[key];
          }
        } else {
          if (key == 'Exempt') {
            this.Exempt = false;
          } else {
            this[key] = null;
          }
        }
      }
    }
  }
}
class SchoolInfo {
  constructor(source) {
    this.Key = undefined;
    this.Name = undefined;
    this.AddressKey = undefined;
    this.Line1 = undefined;
    this.Line2 = undefined;
    this.City = undefined;
    this.State = undefined;
    this.Zip = undefined;
    this.PhoneKey = undefined;
    this.Phone = undefined;
    this.IsInstructorReferral = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
class TrainingRecord {
  constructor(source) {
    this.Key = undefined;
    this.IndividualKey = undefined;
    this.Association = undefined;
    this.License1 = undefined;
    this.License2 = undefined;
    this.School = undefined;
    this.CourseLength = undefined;
    this.GraduationDate = undefined;
    this.NameAttended = undefined;
    this.Primary = undefined;
    this.Added = undefined;
    this.Updated = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          if (key === 'License1') {
            this.License1 = new LicenseInfo(source[key]);
          } else if (key === 'License2') {
            this.License2 = new LicenseInfo(source[key]);
          } else if (key === 'School') {
            this.School = new SchoolInfo(source[key]);
          } else if (key === 'GraduationDate' || key === 'Added' || key === 'Updated') {
            this[key] = source[key] == null ? null : new Date(source[key]);
          } else {
            this[key] = source[key];
          }
        }
      }
    }
    if (!this.License1) {
      this.License1 = new LicenseInfo();
    }
    if (!this.License2) {
      this.License2 = new LicenseInfo();
    }
    if (!this.School) {
      this.School = new SchoolInfo();
    }
  }
}
class MembershipTrainingDetailService {
  get Training$() {
    if (this.training$) {
      return this.training$.asObservable();
    }
    return this.GetPrimaryTrainingRecord(false);
  }
  constructor(appSettings, http) {
    this.appSettings = appSettings;
    this.http = http;
    this.endpoint = this.appSettings.pac_base_nf_url + 'api/PACMembershipTrainingDetail';
    this.training$ = null;
    this.cache = null;
    this.Exempt = new Map([['ABMP', ['KS', 'MN', 'VT', 'WY']], ['ASCP', ['CT']], ['AHP', ['CT']], ['ANP', []]]);
  }
  GetTrainingRecords(cache = true) {
    if (cache && this.cache) {
      return this.cache;
    }
    this.cache = this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(record => new TrainingRecord(record));
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }), shareReplay(1));
    return this.cache;
  }
  GetTrainingRecord(asn, skeleton = null) {
    return this.GetTrainingRecords().pipe(map(results => {
      const matching = results.filter(record => {
        let match = record.Association === asn;
        if (match) {
          if (skeleton) {
            if (record.School.Key && skeleton.School.Key) {
              match = record.School.Key.toLowerCase() == skeleton.School.Key.toLowerCase();
            }
          }
        }
        return match;
      }).sort((a, b) => {
        return a.Added.getTime() - b.Added.getTime();
      });
      if (matching.length === 1) {
        return matching[0];
      } else if (matching.length > 1) {
        const primary = matching.find(record => record.Primary);
        if (primary) {
          return primary;
        }
        return matching[0];
      }
      if (skeleton) {
        const empty = {
          ...skeleton,
          Association: asn,
          Primary: true,
          Key: null
        };
        if (!empty.License1) {
          empty.License1 = {};
        }
        if (!empty.License2) {
          empty.License1 = {};
        }
        if (!empty.School) {
          empty.School = {};
        }
        return empty;
      }
      return null;
    }));
  }
  GetPrimaryTrainingRecord(cache = true) {
    if (!this.training$) {
      this.training$ = new ReplaySubject(1);
    } else if (cache) {
      return this.training$.asObservable();
    } else {
      this.cache = null;
    }
    const all = Assoications.map(asn => this.GetTrainingRecord(asn).pipe(map(record => ({
      asn,
      record
    }))));
    return combineLatest(all).pipe(map(results => {
      const map = new Map();
      results.forEach(({
        asn,
        record
      }) => {
        if (record) {
          map.set(asn, record);
        }
      });
      return map;
    }), tap({
      next: map => this.training$.next(map)
    }), switchMap(map => this.training$.asObservable()));
  }
  Save(record) {
    let save;
    if (record.Key) {
      save = this.http.put(this.endpoint + '/' + record.Key, record, {
        withCredentials: true
      });
    } else {
      save = this.http.post(this.endpoint, record, {
        withCredentials: true
      });
    }
    return save.pipe(catchError(ApiErrorHandler), tap({
      error: LoginExceptionRedirect
    }), map(result => new TrainingRecord(result)), switchMap(result => this.GetPrimaryTrainingRecord(false).pipe(map(map => result))), take(1));
  }
  static {
    this.ɵfac = function MembershipTrainingDetailService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MembershipTrainingDetailService)(i0.ɵɵinject(AppSettings), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: MembershipTrainingDetailService,
      factory: MembershipTrainingDetailService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MembershipTrainingDetailService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: AppSettings
  }, {
    type: i1.HttpClient
  }], null);
})();

// tslint:disable: variable-name
class Membership {
  constructor(source) {
    this.mbr_key = undefined;
    this.mbr_cst_key = undefined;
    this.mbr_asn_code = undefined;
    this.mbr_join_date = undefined;
    this.mbr_rejoin_date = undefined;
    this.mbr_renew_date = undefined;
    this.mbr_expire_date = undefined;
    this.mbr_terminate_date = undefined;
    this.mbr_invoice_date = undefined;
    this.mbr_membership_agreement_flag_dn_ext = undefined;
    this.mbr_p02_key_ext = undefined;
    this.mbs_code = undefined;
    this.mbt_key = undefined;
    this.mbt_code = undefined;
    this.mbt_flip_customer_member_flag = undefined;
    this.mbt_includes_insurance_flag_ext = undefined;
    this.mbr_auto_pay = undefined;
    this.mbr_do_not_renew_flag = undefined;
    this.mbr_installment_payments_flag = undefined;
    this.mbr_num_of_installments_for_renewal = undefined;
    this.mbr_pak_prd_key = undefined;
    this.mbr_cpi_key = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'mbr_join_date':
            case 'mbr_rejoin_date':
            case 'mbr_renew_date':
            case 'mbr_expire_date':
            case 'mbr_terminate_date':
            case 'mbr_invoice_date':
              const k = key;
              if (source[k] == null || source[k] === undefined || source[k] === '') {
                this[k] = null;
              } else {
                const date = moment(source[k]);
                this[k] = date.toDate();
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class Package {
  constructor(source) {
    this.p02_key = undefined;
    this.p02_combo_description = undefined;
    this.p02_combo_price = undefined;
    this.p02_combo_detail_description = undefined;
    this.p02_terms_and_conditions = undefined;
    this.p02_sort_order = undefined;
    this.ABMP = false;
    this.ASCP = false;
    this.AHP = false;
    this.ANP = false;
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
class MembershipService {
  get Memberships$() {
    if (this.memberships$) {
      return this.memberships$.asObservable().pipe(filter(results => results !== undefined));
    } else {
      return this.Get();
    }
  }
  get Package$() {
    if (this.package$) {
      return this.package$.pipe(filter(results => results !== undefined));
    }
    return of(null);
  }
  constructor(http, settings) {
    this.http = http;
    this.resetMemberships = false;
    this.endpoint = settings.pac_base_nf_url + 'api/Membership';
    this.p02endpoint = settings.pac_base_nf_url + 'api/MemberPackageCombo/FindPackageCombo';
  }
  Get(cached = true) {
    if (cached && !this.resetMemberships && this.memberships$) {
      return this.Memberships$;
    }
    if (!this.memberships$) {
      this.memberships$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(mbr => new Membership(mbr));
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.resetMemberships = false;
        this.memberships$.next(results);
      }
    });
    return this.Memberships$;
  }
  Package(memberships) {
    const request = {
      ABMP: null,
      ASCP: null,
      AHP: null,
      ANP: null
    };
    if (!memberships || memberships.length === 0) {
      return of(null);
    }
    for (const mbr of memberships) {
      request[mbr.mbr_asn_code] = mbr.mbt_key;
    }
    this.package$ = new BehaviorSubject(undefined);
    this.http.post(this.p02endpoint, request, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if ('p02_key' in result) {
        return new Package(result);
      }
      return null;
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(result => this.package$.next(result));
    return this.Package$;
  }
  Update(membership) {
    return this.http.put(this.endpoint + '/' + membership.mbr_key, membership, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if ('mbr_key' in result) {
        return new Membership(result);
      }
      return null;
    }), withLatestFrom(this.memberships$), tap(([result, memberships]) => {
      this.resetMemberships = true;
      const update = [result, ...memberships.filter(mbr => mbr.mbr_key !== result.mbr_key)];
      this.memberships$.next(update);
    }), map(([result]) => result), tap({
      error: LoginExceptionRedirect
    }));
  }
  Reset() {
    this.resetMemberships = true;
  }
  static {
    this.ɵfac = function MembershipService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MembershipService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: MembershipService,
      factory: MembershipService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MembershipService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class PaymentHistoryService {
  get PaymentHistory$() {
    return this.paymentHistory$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.paymentHistory$ = null;
    this.details$ = new Map();
    this.endpoint = settings.pac_base_nf_url + 'api/PaymentHistory';
  }
  Get() {
    if (this.paymentHistory$) {
      return this.PaymentHistory$;
    }
    if (this.paymentHistory$ === null) {
      this.paymentHistory$ = new ReplaySubject(1);
    }
    this.Refresh().subscribe(results => {
      if (results instanceof Array) {
        this.paymentHistory$.next(results);
      }
    });
    return this.PaymentHistory$;
  }
  Refresh() {
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(pay => {
          const pay_trx_date = pay.pay_trx_date ?? moment(pay.pay_trx_date).toDate();
          return {
            ...pay,
            pay_trx_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Details(pay_key) {
    if (this.details$.has(pay_key)) {
      return this.details$.get(pay_key);
    }
    var details$ = new ReplaySubject(1);
    this.details$.set(pay_key, details$);
    this.RefreshDetails(pay_key).subscribe(results => {
      if (results instanceof Array) {
        details$.next(results);
      }
    });
    return details$;
  }
  RefreshDetails(pay_key) {
    return this.http.get(this.endpoint + '/' + pay_key, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(pyd => {
          const inv_trx_date = pyd.inv_trx_date ?? moment(pyd.inv_trx_date).toDate();
          return {
            ...pyd,
            inv_trx_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function PaymentHistoryService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentHistoryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PaymentHistoryService,
      factory: PaymentHistoryService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentHistoryService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class PaymentMethodService {
  get PaymentMethods$() {
    return this.paymentMethods$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.paymentMethods$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/PaymentMethod';
  }
  Get() {
    if (this.paymentMethods$) {
      return this.PaymentMethods$;
    }
    if (this.paymentMethods$ === null) {
      this.paymentMethods$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(apm => apm);
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.paymentMethods$.next(results);
      }
    });
    return this.PaymentMethods$;
  }
  static {
    this.ɵfac = function PaymentMethodService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentMethodService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PaymentMethodService,
      factory: PaymentMethodService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentMethodService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class IndividualPhone {
  constructor(source) {
    this.cph_key = undefined;
    this.cph_pht_key = undefined;
    this.cph_primary = undefined;
    this.cph_phn_number_complete = undefined;
    this.cph_extension = undefined;
    this.phn_number = undefined;
    this.phn_number_display = undefined;
    this.phn_cty_key = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class IndividualSMS {
  constructor(source) {
    this.sms_terms_conditions = undefined;
    this.sms_phone_number = undefined;
    this.sms_help_message = undefined;
    this.sms_association_name = undefined;
    this.sms_frequency_rates = undefined;
    this.sms_calltoaction = undefined;
    this.cst_cph_sms_key = undefined;
    this.cst_sms_opt = undefined;
    this.cst_sms_consent_type = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
  get OptedIn() {
    return this.cst_sms_opt === 'Opt In';
  }
}
const PhoneTypes = [{
  'pht_key': '52ab7c1d-fe7d-466b-95c0-b715d9649215',
  'pht_code': 'Mobile'
}, {
  'pht_key': '3a4e6f64-9cd5-40a5-b04e-ad63882f16f3',
  'pht_code': 'Landline'
}];
class PhoneService {
  get IndividualPhone$() {
    if (!this.individualPhone$) {
      this.Get();
    }
    return this.individualPhone$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.IndividualSMS$ = new BehaviorSubject(undefined);
    this.reset = false;
    this.endpoint = settings.pac_base_nf_url + 'api/IndividualPhone';
    this.smsEndpoint = settings.pac_base_nf_url + 'api/SMS';
  }
  Get(cached = true) {
    if (cached && this.individualPhone$ && this.reset === false) {
      return this.IndividualPhone$;
    }
    if (!this.individualPhone$) {
      this.individualPhone$ = new BehaviorSubject(undefined);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(phn => new IndividualPhone(phn));
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.reset = false;
        this.individualPhone$.next(results);
      }
    });
    return this.IndividualPhone$;
  }
  Reset() {
    this.reset = true;
  }
  Update(phn) {
    return this.http.put(this.endpoint + '/' + phn.cph_key, phn, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cph_key' in result) {
        return new IndividualPhone(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof IndividualPhone) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Insert(phn) {
    return this.http.post(this.endpoint, phn, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'cph_key' in result) {
        return new IndividualPhone(result);
      }
      return null;
    }), tap(result => {
      if (result instanceof IndividualPhone) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  GetSMS() {
    return this.http.get(this.smsEndpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      let sms = new IndividualSMS(results);
      this.IndividualSMS$.next(sms);
      return sms;
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  OptIn(cph_key) {
    let data = {
      cst_sms_opt: 'Opt In',
      cst_cph_sms_key: cph_key,
      cst_sms_consent_type: 'my-membership'
    };
    return this.http.post(this.smsEndpoint, data, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      let sms = new IndividualSMS(results);
      this.IndividualSMS$.next(sms);
      return sms;
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  OptOut() {
    let data = {
      cst_sms_opt: 'Opt Out'
    };
    return this.http.post(this.smsEndpoint, data, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      let sms = new IndividualSMS(results);
      this.IndividualSMS$.next(sms);
      return sms;
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function PhoneService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PhoneService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: PhoneService,
      factory: PhoneService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class InvoiceDetail {
  constructor(source) {
    this.ivd_key = undefined;
    this.ivd_mbr_key = undefined;
    this.ivd_pak_prd_key = undefined;
    this.ptp_code = undefined;
    this.prd_key = undefined;
    this.prd_atc_key = undefined;
    this.prd_code = undefined;
    this.prc_key = undefined;
    this.prc_code = undefined;
    this.prc_display_name = undefined;
    this.prc_price = undefined;
    this.ivd_price = undefined;
    this.ivd_discountamount = undefined;
    this.ivd_total = undefined;
    this.ivd_balance = undefined;
    this.ivd_netpayment = undefined;
    this.inv_key = undefined;
    this.inv_trx_date = undefined;
    this.inv_ord_key = undefined;
    this.inv_orig_trans_type = undefined;
    this.atc_code = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'ivd_price':
            case 'ivd_discountamount':
            case 'ivd_total':
            case 'ivd_balance':
            case 'ivd_netpayment':
            case 'prc_price':
              const floatKey = key;
              if (source[floatKey] == null || source[floatKey] === undefined || source[floatKey] === '') {
                this[floatKey] = null;
              } else {
                this[floatKey] = parseFloat(source[floatKey]);
              }
              break;
            case 'inv_trx_date':
              const inv_trx_date = source[key] ?? new Date(source[key]);
              this[key] = inv_trx_date;
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class InvoiceDetailSubscription extends InvoiceDetail {
  constructor(source) {
    super(source);
    this.trm_start_date = undefined;
    this.trm_end_date = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'trm_start_date':
            case 'trm_end_date':
              const dateKey = key;
              if (source[dateKey] == null || source[dateKey] === undefined || source[dateKey] === '') {
                this[dateKey] = null;
              } else {
                const date = moment(source[dateKey]);
                this[dateKey] = date.toDate();
              }
          }
        }
      }
    }
  }
}
class SubscriptionService {
  get Subscriptions$() {
    return this.subscriptions$.asObservable().pipe(filter(results => results !== undefined));
  }
  constructor(http, settings) {
    this.http = http;
    this.subscriptions$ = null;
    this.reset = false;
    this.endpoint = settings.pac_base_nf_url + 'api/InvoiceDetailTerm';
  }
  Get(cached = true) {
    if (cached && !this.reset && this.subscriptions$) {
      return this.Subscriptions$;
    }
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(trm => new InvoiceDetailSubscription(trm));
      }
      return [];
    }), tap(results => {
      if (results instanceof Array) {
        if (this.subscriptions$ === null) {
          this.subscriptions$ = new BehaviorSubject(undefined);
        }
        this.reset = false;
        this.subscriptions$.next(results);
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Reset() {
    this.reset = true;
  }
  static {
    this.ɵfac = function SubscriptionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SubscriptionService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: SubscriptionService,
      factory: SubscriptionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubscriptionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class TagService {
  get Tags$() {
    if (!this.tags$) {
      this.Get();
    }
    return this.tags$.asObservable();
  }
  constructor(http, settings) {
    this.http = http;
    this.reset = false;
    this.endpoint = settings.pac_base_nf_url + 'api/PACTag';
  }
  Get(cached = true) {
    if (cached && this.tags$ && this.reset === false) {
      return this.Tags$;
    }
    if (!this.tags$) {
      this.tags$ = new ReplaySubject(1);
    }
    this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results;
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    })).subscribe(results => {
      if (results instanceof Array) {
        this.reset = false;
        this.tags$.next(results);
      }
    });
    return this.Tags$;
  }
  Reset() {
    this.reset = true;
  }
  Update(tag) {
    return this.http.put(this.endpoint + '/' + tag.p34_key, tag, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'p34_key' in result) {
        return result;
      }
      return null;
    }), tap(result => {
      if (result) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Insert(tag) {
    return this.http.post(this.endpoint, tag, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result && 'p34_key' in result) {
        return result;
      }
      return null;
    }), tap(result => {
      if (result) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Delete(tag) {
    return this.http.delete(this.endpoint + '/' + tag.p34_key, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), mapTo(true), tap(result => {
      if (result) {
        this.reset = true;
      }
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function TagService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TagService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: TagService,
      factory: TagService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class TaxonomyTerm {
  constructor(source) {
    this.tid = undefined;
    this.vid = undefined;
    this.name = undefined;
    this.description = undefined;
    this.vocabulary_machine_name = undefined;
    this.path = undefined;
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
class TaxonomyService {
  constructor(http, appSettings) {
    this.http = http;
    this.appSettings = appSettings;
    this.endpoint = '/pac-base/taxonomy/';
    this.cacheList = new Map();
    this.cacheOne = new Map();
  }
  GetTaxonomy(vocabulary, cache = true) {
    if (cache && this.cacheList.has(vocabulary)) {
      return this.cacheList.get(vocabulary);
    }
    const get = this.http.get(this.endpoint + vocabulary, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), tap({
      error: LoginExceptionRedirect
    }), map(results => {
      if (results instanceof Array) {
        return results.map(result => new TaxonomyTerm(result));
      }
      return [];
    }), shareReplay(1));
    this.cacheList.set(vocabulary, get);
    return this.cacheList.get(vocabulary);
  }
  GetTaxonomyTerm(vocabulary, term, asn, cache = true) {
    const key = (asn ? asn : this.appSettings.pac_base_asn_code) + '-' + vocabulary + '-' + term;
    if (cache && this.cacheOne.has(key)) {
      return this.cacheOne.get(key);
    }
    let url;
    if (!asn || asn === this.appSettings.pac_base_asn_code) {
      url = this.endpoint;
    } else {
      url = this.appSettings.systemoptions['PAC.Web.' + asn] + this.endpoint.substring(1);
    }
    url += vocabulary + '/' + term;
    const get = this.http.get(url, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), tap({
      error: LoginExceptionRedirect
    }), map(result => {
      if ('tid' in result) {
        return new TaxonomyTerm(result);
      }
      return null;
    }), shareReplay(1));
    this.cacheOne.set(key, get);
    return this.cacheOne.get(key);
  }
  static {
    this.ɵfac = function TaxonomyService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TaxonomyService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: TaxonomyService,
      factory: TaxonomyService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaxonomyService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
let appSettings;
;
class PacApiModule {
  static {
    this.configDefaults = {
      skipAppSettings: false
    };
  }
  static forRoot(config = {}) {
    const _config = {
      ...PacApiModule.configDefaults,
      ...config
    };
    const providers = [{
      provide: WindowToken,
      useValue: window || {}
    }, AddressService, AieService, AssociationService, BootstrapClassMapperService, ComplianceDetailService, CustomerPaymentInfoService, GoogleTagManagerService, IndividualAffiliationService, IndividualResolver, IndividualService, MembershipRenewalsProcessService, MembershipService, MembershipTrainingDetailService, PaymentHistoryService, PaymentMethodService, PhoneService, SubscriptionService, TagService, TaxonomyService];
    if (_config.skipAppSettings) {
      appSettings = null;
    } else {
      appSettings = new AppSettings();
      providers.push({
        provide: AppSettings,
        useValue: appSettings
      });
    }
    return {
      ngModule: PacApiModule,
      providers
    };
  }
  constructor() {
    if (appSettings instanceof AppSettings) {
      if ('MyMembership' in window && window.MyMembership) {
        if ('Settings' in window.MyMembership && window.MyMembership.Settings) {
          Object.assign(appSettings, window.MyMembership.Settings);
        }
      }
    }
  }
  static {
    this.ɵfac = function PacApiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PacApiModule)();
    };
  }
  static {
    this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
      type: PacApiModule
    });
  }
  static {
    this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
      imports: [CommonModule, ReactiveFormsModule, AlertModule, RecaptchaModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PacApiModule, [{
    type: NgModule,
    args: [{
      declarations: [BsClassDirective, BsMigrationDirective, CcDisplayPipe, CxaMailingPipe, D7AjaxBlockComponent, HeaderDirective, LoadingComponent, PaymentDetailsComponent, PaymentInfoComponent, BsMigrationPickerDirective, SiteMailComponent, SitePhoneComponent, DynamicModalComponent, FetchModalComponent],
      imports: [CommonModule, ReactiveFormsModule, AlertModule, RecaptchaModule],
      exports: [BsClassDirective, BsMigrationDirective, CcDisplayPipe, CxaMailingPipe, D7AjaxBlockComponent, HeaderDirective, LoadingComponent, PaymentDetailsComponent, PaymentInfoComponent, BsMigrationPickerDirective, SiteMailComponent, SitePhoneComponent, DynamicModalComponent, FetchModalComponent]
    }]
  }], () => [], null);
})();
(function () {
  (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PacApiModule, {
    declarations: [BsClassDirective, BsMigrationDirective, CcDisplayPipe, CxaMailingPipe, D7AjaxBlockComponent, HeaderDirective, LoadingComponent, PaymentDetailsComponent, PaymentInfoComponent, BsMigrationPickerDirective, SiteMailComponent, SitePhoneComponent, DynamicModalComponent, FetchModalComponent],
    imports: [CommonModule, ReactiveFormsModule, AlertModule, RecaptchaModule],
    exports: [BsClassDirective, BsMigrationDirective, CcDisplayPipe, CxaMailingPipe, D7AjaxBlockComponent, HeaderDirective, LoadingComponent, PaymentDetailsComponent, PaymentInfoComponent, BsMigrationPickerDirective, SiteMailComponent, SitePhoneComponent, DynamicModalComponent, FetchModalComponent]
  });
})();
const now = new Date();
function CurrentMembership(memberships) {
  let recent;
  const Memberships = Enumerable.from(memberships);
  if (Memberships.any(mbr => mbr.mbr_terminate_date === null)) {
    // Find current membership group
    if (Memberships.any(mbr => mbr.mbr_expire_date === null)) {
      // Something is weird, don't continue
      throw new Error('Memberships are missing an expiration date.');
    }
    const max = Memberships.maxBy(mbr => mbr.mbr_expire_date).mbr_expire_date.getTime();
    recent = Memberships.where(mbr => mbr.mbr_expire_date.getTime() === max);
  } else if (Memberships.any(mbr => mbr.mbr_terminate_date !== null)) {
    // Find previous group by terminate date
    const max = Memberships.maxBy(mbr => mbr.mbr_terminate_date).mbr_terminate_date.getTime();
    recent = Memberships.where(mbr => mbr.mbr_terminate_date.getTime() === max);
  } else {
    throw new Error('No current or past membership have been found.');
  }
  return recent;
}
function Active(membership) {
  return (membership.mbr_terminate_date === null || membership.mbr_terminate_date === undefined) && membership.mbr_expire_date instanceof Date && membership.mbr_expire_date > now;
}
function ActiveMembership(memberships) {
  const Memberships = Enumerable.from(memberships);
  return Memberships.where(Active);
}
function ExpireDate(memberships) {
  if (memberships === null) {
    return null;
  }
  const first = memberships.first();
  if (first) {
    return first.mbr_terminate_date ? first.mbr_terminate_date : first.mbr_expire_date;
  } else {
    return null;
  }
}
function AutoRenew(mbr) {
  return mbr.mbr_auto_pay && !mbr.mbr_do_not_renew_flag;
}
function InstallmentPayments(mbr) {
  return mbr.mbr_installment_payments_flag && mbr.mbr_num_of_installments_for_renewal >= 4;
}
function IncludesInsurance(mbr) {
  return mbr.mbt_includes_insurance_flag_ext;
}
class DateValidators {
  static PastDate(control) {
    if (control.value) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const date = new Date(control.value);
      date.setHours(0, 0, 0, 0);
      if (date > now) {
        return {
          'PastDate': true
        };
      }
    }
    return null;
  }
  static FutureDate(control) {
    if (control.value) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const date = new Date(control.value);
      date.setHours(0, 0, 0, 0);
      if (date < now) {
        return {
          'FutureDate': true
        };
      }
    }
    return null;
  }
  static PlausibleDate(control) {
    if (control.value) {
      const min = new Date(1930, 1, 1, 0, 0, 0, 0);
      const max = new Date(2030, 12, 31, 0, 0, 0, 0);
      const date = new Date(control.value);
      if (!isNaN(date.valueOf()) && (date < min || date > max)) {
        return {
          'PlausibleDate': true
        };
      }
    }
    return null;
  }
  static ValidDate(control) {
    if (control.value) {
      const date = new Date(control.value);
      if (date instanceof Date) {
        if (isNaN(date.valueOf()) === false) {
          return null;
        }
      }
      return {
        'ValidDate': true
      };
    }
    return null;
  }
}
const RouteParse = (attribute, fallback) => snapshot => snapshot.firstChild && attribute in snapshot.firstChild.data ? typeof snapshot.firstChild.data[attribute] === 'function' ? snapshot.firstChild.data[attribute](snapshot.firstChild) : snapshot.firstChild.data[attribute] : attribute in snapshot.data ? snapshot.data[attribute] : fallback;
const RouteTitleParse = RouteParse('title', null);
const RouteAddParse = RouteParse('add', []);
function ImplementsBusy(object) {
  return 'Busy$' in object && object.Busy$ instanceof Observable;
}
class BusyParentRoute {
  constructor() {
    this.Busy$ = new BehaviorSubject(false);
    this.childSink = new SubSink();
  }
  onActivate(component) {
    if (ImplementsBusy(component)) {
      this.childSink.sink = component.Busy$.subscribe(this.Busy$);
    }
  }
  onDeactivate(component) {
    if (this.childSink && ImplementsBusy(component)) {
      this.childSink.unsubscribe();
      if (this.Busy$.value) {
        this.Busy$.next(false);
      }
    }
  }
}
;
var Gender;
(function (Gender) {
  Gender[Gender["Male"] = 0] = "Male";
  Gender[Gender["Female"] = 1] = "Female";
  Gender[Gender["Other"] = 2] = "Other";
})(Gender || (Gender = {}));

// https://github.com/sahava/datalayer-typescript/blob/master/types.ts

class Organization {
  constructor(source) {
    this.cst_key = undefined;
    this.cst_recno = undefined;
    this.cst_phn_number_complete_dn = undefined;
    this.cxa_mailing_label = undefined;
    this.org_name = undefined;
    this.org_affinity_payment_optin_flag_ext = undefined;
    this.org_affinity_payment_type_ext = undefined;
    this.org_affinity_payment_combo_packages_ext = undefined;
    this.adr_line1 = undefined;
    this.adr_city = undefined;
    this.adr_state = undefined;
    this.adr_post_code = undefined;
    this.IsInstructorReferral = undefined;
    this.Tier = {
      'ABMP': null,
      'ASCP': null,
      'AHP': null,
      'ANP': null
    };
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'cst_recno':
              const cst_recno = parseInt(source.cst_recno, 10) || null;
              this.cst_recno = cst_recno;
              break;
            case 'Tier':
              for (const asn in source.Tier) {
                if (source.Tier.hasOwnProperty(asn)) {
                  this.Tier[asn] = source.Tier[asn];
                }
              }
              break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }
}
class RichError extends Error {
  constructor(htmlError, text = null) {
    super(text || _unwrapSafeValue(htmlError).replace(/<[^>]+>/gm, ''));
    this.htmlError = htmlError;
  }
  get Html() {
    return this.htmlError;
  }
}
class AffinityPortalService {
  constructor(settings, http) {
    this.settings = settings;
    this.http = http;
    this.endpoint = this.settings.pac_base_nf_url + 'api/AffinityPortal/';
  }
  GetOrganization(cst_recno, primary = true) {
    const url = primary ? '/pac-wizard/affinity/' + cst_recno : this.endpoint + 'Organization/' + cst_recno;
    return this.http.get(url, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => new Organization(result)), shareReplay(1));
  }
  GetLocations(cst_recno) {
    return this.http.get(this.endpoint + 'Locations/' + cst_recno, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result instanceof Array) {
        return result.map(item => new Organization(item));
      }
      return [];
    }), shareReplay(1));
  }
  vw_client_pac_emp_eligible_memberships() {
    return this.http.get(this.endpoint + 'vw_client_pac_emp_eligible_memberships', {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result instanceof Array) {
        return result.map(item => {
          if ('mbr_exp_date' in item && item.mbr_exp_date) {
            item.mbr_exp_date = new Date(item.mbr_exp_date);
          } else {
            item.mbr_exp_date = null;
          }
          return item;
        });
      }
      return [];
    }), shareReplay(1));
  }
  static {
    this.ɵfac = function AffinityPortalService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AffinityPortalService)(i0.ɵɵinject(AppSettings), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: AffinityPortalService,
      factory: AffinityPortalService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AffinityPortalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: AppSettings
  }, {
    type: i1.HttpClient
  }], null);
})();

/**
 * @deprecated This is just a stub for the client_pac_ord_x_mbr. You probably want the Cart service from the signup wizard.
 */
class CartService {
  constructor(settings, http) {
    this.settings = settings;
    this.http = http;
    this.endpoint = this.settings.pac_base_nf_url + 'api/Cart/';
  }
  client_pac_ord_x_mbr() {
    return this.http.get(this.endpoint + 'client_pac_ord_x_mbr', {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(result => {
      if (result instanceof Array) {
        return result;
      }
      return [];
    }), shareReplay(1));
  }
  static {
    this.ɵfac = function CartService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CartService)(i0.ɵɵinject(AppSettings), i0.ɵɵinject(i1.HttpClient));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: CartService,
      factory: CartService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: AppSettings
  }, {
    type: i1.HttpClient
  }], null);
})();
class InstallmentPaymentService {
  get InstallmentPayment$() {
    return this.installmentPayment$.asObservable();
  }
  constructor(http, settings) {
    this.http = http;
    this.installmentPayment$ = null;
    this.details$ = new Map();
    this.endpoint = settings.pac_base_nf_url + 'api/InstallmentBilling';
  }
  Get() {
    if (this.installmentPayment$) {
      return this.InstallmentPayment$;
    }
    if (this.installmentPayment$ === null) {
      this.installmentPayment$ = new ReplaySubject(1);
    }
    this.Refresh().subscribe(results => {
      if (results instanceof Array) {
        this.installmentPayment$.next(results);
      }
    });
    return this.InstallmentPayment$;
  }
  Refresh() {
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(ord => {
          const ord_trx_date = ord.ord_trx_date ?? moment(ord.ord_trx_date).toDate(),
            ord_first_process_date = ord.ord_first_process_date ?? moment(ord.ord_first_process_date).toDate(),
            ord_last_bill_date = ord.ord_last_bill_date ?? moment(ord.ord_last_bill_date).toDate();
          return {
            ...ord,
            ord_trx_date,
            ord_first_process_date,
            ord_last_bill_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  Details(ord_key) {
    if (this.details$.has(ord_key)) {
      return this.details$.get(ord_key);
    }
    var details$ = new ReplaySubject(1);
    this.details$.set(ord_key, details$);
    this.RefreshDetails(ord_key).subscribe(results => {
      if (results instanceof Array) {
        details$.next(results);
      }
    });
    return details$;
  }
  RefreshDetails(ord_key) {
    return this.http.get(this.endpoint + '/' + ord_key, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(ods => {
          const ods_date = ods.ods_date ?? moment(ods.ods_date).toDate(),
            ods_process_date = ods.ods_process_date ?? moment(ods.ods_process_date).toDate();
          return {
            ...ods,
            ods_date,
            ods_process_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function InstallmentPaymentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InstallmentPaymentService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: InstallmentPaymentService,
      factory: InstallmentPaymentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InstallmentPaymentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();
class InvoiceService {
  get Invoice$() {
    return this.invoice$.asObservable();
  }
  constructor(http, settings) {
    this.http = http;
    this.invoice$ = null;
    this.endpoint = settings.pac_base_nf_url + 'api/Invoice';
  }
  Get() {
    if (this.invoice$) {
      return this.Invoice$;
    }
    if (this.invoice$ === null) {
      this.invoice$ = new ReplaySubject(1);
    }
    this.Refresh().subscribe(results => {
      if (results instanceof Array) {
        this.invoice$.next(results);
      }
    });
    return this.Invoice$;
  }
  Refresh() {
    return this.http.get(this.endpoint, {
      withCredentials: true
    }).pipe(catchError(ApiErrorHandler), map(results => {
      if (results instanceof Array) {
        return results.map(inv => {
          const inv_trx_date = inv.inv_trx_date ?? moment(inv.inv_trx_date).toDate();
          ;
          return {
            ...inv,
            inv_trx_date
          };
        });
      }
      return [];
    }), tap({
      error: LoginExceptionRedirect
    }));
  }
  static {
    this.ɵfac = function InvoiceService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InvoiceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AppSettings));
    };
  }
  static {
    this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
      token: InvoiceService,
      factory: InvoiceService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvoiceService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: AppSettings
  }], null);
})();

/*
 * Public API Surface of pac-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Active, ActiveMembership, AddressService, AffinityPortalService, AieService, ApiError, ApiErrorHandler, ApiErrors, AppSettings, AsnLogo, AsnOrder, AsnSort, AssociationService, Assoications, AutoRenew, BootstrapClassMapperService, BootstrapVersion, BsClassDirective, BsMigrationDirective, BsMigrationPickerDirective, BusyParentRoute, CartService, CcDisplayPipe, ComplianceDetailService, CurrentMembership, CustomerPaymentInfo, CustomerPaymentInfoService, CxaMailingPipe, D7AjaxBlockComponent, DateValidators, DrupalVersion, DynamicModalComponent, ExpireDate, FetchModalComponent, Gender, GoogleTagManagerService, HeaderDefaultDestination, HeaderDirective, INDIVIDUAL, ImplementsBusy, IncludesInsurance, Individual, IndividualAddress, IndividualAffiliation, IndividualAffiliationService, IndividualPhone, IndividualResolver, IndividualService, InstallmentPaymentService, InstallmentPayments, InvoiceDetail, InvoiceDetailSubscription, InvoiceService, LicenseInfo, LoadingComponent, LoginExceptionRedirect, LoginExceptionRedirectFactory, LoginExceptionRedirectToken, LoginResult, Membership, MembershipRenewalsProcessService, MembershipService, MembershipTrainingDetailService, Organization, PacApiModule, Package, PaymentAfterSave, PaymentBeforeSave, PaymentDetailsComponent, PaymentError, PaymentHistoryService, PaymentInfoComponent, PaymentMethodService, PhoneService, PhoneTypes, RichError, RouteAddParse, RouteTitleParse, SchoolInfo, SiteMailComponent, SitePhoneComponent, SubscriptionService, TagService, TaxonomyService, TaxonomyTerm, TrainingRecord, WindowToken };
